/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { ClosedEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export const PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsAccountStatus =
  {
    AccountStatusUnspecified: "ACCOUNT_STATUS_UNSPECIFIED",
    AccountStatusActive: "ACCOUNT_STATUS_ACTIVE",
    AccountStatusSuspended: "ACCOUNT_STATUS_SUSPENDED",
    AccountStatusPendingVerification: "ACCOUNT_STATUS_PENDING_VERIFICATION",
  } as const;
export type PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsAccountStatus =
  ClosedEnum<
    typeof PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsAccountStatus
  >;

export const PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsRoles =
  {
    RoleUnspecified: "ROLE_UNSPECIFIED",
    RoleAdmin: "ROLE_ADMIN",
    RoleUser: "ROLE_USER",
    RoleViewer: "ROLE_VIEWER",
    RoleManager: "ROLE_MANAGER",
  } as const;
export type PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsRoles =
  ClosedEnum<
    typeof PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsRoles
  >;

export const PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsPermissions =
  {
    PermissionUnspecified: "PERMISSION_UNSPECIFIED",
    PermissionRead: "PERMISSION_READ",
    PermissionWrite: "PERMISSION_WRITE",
    PermissionDelete: "PERMISSION_DELETE",
    PermissionManageUsers: "PERMISSION_MANAGE_USERS",
    PermissionManageBilling: "PERMISSION_MANAGE_BILLING",
    PermissionViewAnalytics: "PERMISSION_VIEW_ANALYTICS",
    PermissionManageWorkflows: "PERMISSION_MANAGE_WORKFLOWS",
  } as const;
export type PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsPermissions =
  ClosedEnum<
    typeof PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsPermissions
  >;

export const PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTimezone =
  {
    TimezoneUnspecified: "TIMEZONE_UNSPECIFIED",
    TimezoneUtc: "TIMEZONE_UTC",
    TimezoneEst: "TIMEZONE_EST",
    TimezoneCst: "TIMEZONE_CST",
    TimezoneMst: "TIMEZONE_MST",
    TimezonePst: "TIMEZONE_PST",
    TimezoneGmt: "TIMEZONE_GMT",
    TimezoneCet: "TIMEZONE_CET",
    TimezoneIst: "TIMEZONE_IST",
    TimezoneJst: "TIMEZONE_JST",
    TimezoneAest: "TIMEZONE_AEST",
  } as const;
export type PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTimezone =
  ClosedEnum<
    typeof PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTimezone
  >;

export const PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsStatus =
  {
    WorkflowStatusUnspecified: "WORKFLOW_STATUS_UNSPECIFIED",
    WorkflowStatusDraft: "WORKFLOW_STATUS_DRAFT",
    WorkflowStatusActive: "WORKFLOW_STATUS_ACTIVE",
    WorkflowStatusPaused: "WORKFLOW_STATUS_PAUSED",
    WorkflowStatusFailed: "WORKFLOW_STATUS_FAILED",
    WorkflowStatusCompleted: "WORKFLOW_STATUS_COMPLETED",
    WorkflowStatusArchived: "WORKFLOW_STATUS_ARCHIVED",
    WorkflowStatusPendingApproval: "WORKFLOW_STATUS_PENDING_APPROVAL",
    WorkflowStatusValidating: "WORKFLOW_STATUS_VALIDATING",
    WorkflowStatusQuotaExceeded: "WORKFLOW_STATUS_QUOTA_EXCEEDED",
    WorkflowStatusWarning: "WORKFLOW_STATUS_WARNING",
  } as const;
export type PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsStatus =
  ClosedEnum<
    typeof PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsStatus
  >;

export const PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsStatus =
  {
    BackgroundJobStatusUnspecified: "BACKGROUND_JOB_STATUS_UNSPECIFIED",
    BackgroundJobStatusQueued: "BACKGROUND_JOB_STATUS_QUEUED",
    BackgroundJobStatusInProgress: "BACKGROUND_JOB_STATUS_IN_PROGRESS",
    BackgroundJobStatusCompleted: "BACKGROUND_JOB_STATUS_COMPLETED",
    BackgroundJobStatusFailed: "BACKGROUND_JOB_STATUS_FAILED",
    BackgroundJobStatusCancelled: "BACKGROUND_JOB_STATUS_CANCELLED",
    BackgroundJobStatusTimedOut: "BACKGROUND_JOB_STATUS_TIMED_OUT",
  } as const;
export type PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsStatus =
  ClosedEnum<
    typeof PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsStatus
  >;

export const PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsLang =
  {
    LanguageUnspecified: "LANGUAGE_UNSPECIFIED",
    LanguageEnglish: "LANGUAGE_ENGLISH",
    LanguageSpanish: "LANGUAGE_SPANISH",
    LanguageFrench: "LANGUAGE_FRENCH",
    LanguageGerman: "LANGUAGE_GERMAN",
    LanguageItalian: "LANGUAGE_ITALIAN",
    LanguagePortuguese: "LANGUAGE_PORTUGUESE",
    LanguageDutch: "LANGUAGE_DUTCH",
    LanguageRussian: "LANGUAGE_RUSSIAN",
    LanguageChinese: "LANGUAGE_CHINESE",
    LanguageJapanese: "LANGUAGE_JAPANESE",
    LanguageKorean: "LANGUAGE_KOREAN",
    LanguageArabic: "LANGUAGE_ARABIC",
    LanguageHindi: "LANGUAGE_HINDI",
    LanguageGreek: "LANGUAGE_GREEK",
    LanguageTurkish: "LANGUAGE_TURKISH",
  } as const;
export type PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsLang =
  ClosedEnum<
    typeof PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsLang
  >;

export const PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsDay =
  {
    DayOfWeekUnspecified: "DAY_OF_WEEK_UNSPECIFIED",
    DayOfWeekMonday: "DAY_OF_WEEK_MONDAY",
    DayOfWeekTuesday: "DAY_OF_WEEK_TUESDAY",
    DayOfWeekWednesday: "DAY_OF_WEEK_WEDNESDAY",
    DayOfWeekThursday: "DAY_OF_WEEK_THURSDAY",
    DayOfWeekFriday: "DAY_OF_WEEK_FRIDAY",
    DayOfWeekSaturday: "DAY_OF_WEEK_SATURDAY",
    DayOfWeekSunday: "DAY_OF_WEEK_SUNDAY",
  } as const;
export type PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsDay =
  ClosedEnum<
    typeof PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsDay
  >;

export type PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsRegularHours =
  {
    id?: string | undefined;
    day?:
      | PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsDay
      | undefined;
    openTime?: string | undefined;
    closeTime?: string | undefined;
    closed?: boolean | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    deletedAt?: Date | undefined;
  };

export const PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsDay =
  {
    DayOfWeekUnspecified: "DAY_OF_WEEK_UNSPECIFIED",
    DayOfWeekMonday: "DAY_OF_WEEK_MONDAY",
    DayOfWeekTuesday: "DAY_OF_WEEK_TUESDAY",
    DayOfWeekWednesday: "DAY_OF_WEEK_WEDNESDAY",
    DayOfWeekThursday: "DAY_OF_WEEK_THURSDAY",
    DayOfWeekFriday: "DAY_OF_WEEK_FRIDAY",
    DayOfWeekSaturday: "DAY_OF_WEEK_SATURDAY",
    DayOfWeekSunday: "DAY_OF_WEEK_SUNDAY",
  } as const;
export type PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsDay =
  ClosedEnum<
    typeof PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsDay
  >;

export type PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsSpecialHours =
  {
    id?: string | undefined;
    day?:
      | PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsDay
      | undefined;
    openTime?: string | undefined;
    closeTime?: string | undefined;
    closed?: boolean | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    deletedAt?: Date | undefined;
  };

export type PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsReviews =
  {
    id?: string | undefined;
    author?: string | undefined;
    rating?: number | undefined;
    text?: string | undefined;
    time?: Date | undefined;
    language?: string | undefined;
    profilePhotoUrl?: string | undefined;
    reviewCount?: number | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    deletedAt?: Date | undefined;
  };

export const PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsRevenueRange =
  {
    RevenueRangeUnspecified: "REVENUE_RANGE_UNSPECIFIED",
    RevenueRangeUnder100K: "REVENUE_RANGE_UNDER_100K",
    RevenueRange100KTo1M: "REVENUE_RANGE_100K_TO_1M",
    RevenueRange1MTo10M: "REVENUE_RANGE_1M_TO_10M",
    RevenueRange10MTo50M: "REVENUE_RANGE_10M_TO_50M",
    RevenueRangeOver50M: "REVENUE_RANGE_OVER_50M",
  } as const;
export type PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsRevenueRange =
  ClosedEnum<
    typeof PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsRevenueRange
  >;

export const PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsEmployeeBenefits =
  {
    EmployeeBenefitUnspecified: "EMPLOYEE_BENEFIT_UNSPECIFIED",
    EmployeeBenefitHealthInsurance: "EMPLOYEE_BENEFIT_HEALTH_INSURANCE",
    EmployeeBenefitRetirementPlan: "EMPLOYEE_BENEFIT_RETIREMENT_PLAN",
    EmployeeBenefitPaidTimeOff: "EMPLOYEE_BENEFIT_PAID_TIME_OFF",
    EmployeeBenefitRemoteWork: "EMPLOYEE_BENEFIT_REMOTE_WORK",
  } as const;
export type PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsEmployeeBenefits =
  ClosedEnum<
    typeof PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsEmployeeBenefits
  >;

export type PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsLeads =
  {
    id?: string | undefined;
    name?: string | undefined;
    website?: string | undefined;
    phone?: string | undefined;
    address?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    country?: string | undefined;
    latitude?: number | undefined;
    longitude?: number | undefined;
    googleRating?: number | undefined;
    reviewCount?: number | undefined;
    industry?: string | undefined;
    employeeCount?: number | undefined;
    estimatedRevenue?: string | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    deletedAt?: Date | undefined;
    placeId?: string | undefined;
    googleMapsUrl?: string | undefined;
    businessStatus?: string | undefined;
    regularHours?:
      | Array<
        PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsRegularHours
      >
      | undefined;
    specialHours?:
      | Array<
        PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsSpecialHours
      >
      | undefined;
    photoReferences?: Array<string> | undefined;
    mainPhotoUrl?: string | undefined;
    reviews?:
      | Array<
        PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsReviews
      >
      | undefined;
    types?: Array<string> | undefined;
    amenities?: Array<string> | undefined;
    servesVegetarianFood?: boolean | undefined;
    outdoorSeating?: boolean | undefined;
    paymentMethods?: Array<string> | undefined;
    wheelchairAccessible?: boolean | undefined;
    parkingAvailable?: boolean | undefined;
    socialMedia?: { [k: string]: string } | undefined;
    ratingCategory?: string | undefined;
    rating?: number | undefined;
    count?: number | undefined;
    lastUpdated?: Date | undefined;
    dataSourceVersion?: string | undefined;
    scrapingSessionId?: string | undefined;
    alternatePhones?: Array<string> | undefined;
    contactPersonName?: string | undefined;
    contactPersonTitle?: string | undefined;
    contactEmail?: string | undefined;
    foundedYear?: number | undefined;
    businessType?: string | undefined;
    certifications?: Array<string> | undefined;
    licenseNumber?: string | undefined;
    revenueRange?:
      | PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsRevenueRange
      | undefined;
    fundingStage?: string | undefined;
    isPublicCompany?: boolean | undefined;
    websiteLoadSpeed?: number | undefined;
    hasSslCertificate?: boolean | undefined;
    cmsUsed?: string | undefined;
    ecommercePlatforms?: Array<string> | undefined;
    timezone?: string | undefined;
    neighborhood?: string | undefined;
    nearbyLandmarks?: Array<string> | undefined;
    transportationAccess?: string | undefined;
    employeeBenefits?:
      | Array<
        PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsEmployeeBenefits
      >
      | undefined;
    parentCompany?: string | undefined;
    subsidiaries?: Array<string> | undefined;
    isFranchise?: boolean | undefined;
    seoKeywords?: Array<string> | undefined;
    usesGoogleAds?: boolean | undefined;
    googleMyBusinessCategory?: string | undefined;
    naicsCode?: string | undefined;
    sicCode?: string | undefined;
    unspscCode?: string | undefined;
    isGreenCertified?: boolean | undefined;
    energySources?: Array<string> | undefined;
    sustainabilityRating?: string | undefined;
    recentAnnouncements?: Array<string> | undefined;
    lastProductLaunch?: Date | undefined;
    hasLitigationHistory?: boolean | undefined;
    exportControlStatus?: string | undefined;
  };

export type PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsJobs =
  {
    id?: string | undefined;
    priority?: number | undefined;
    payloadType?: string | undefined;
    payload?: string | undefined;
    createdAt?: Date | undefined;
    status?:
      | PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsStatus
      | undefined;
    name?: string | undefined;
    keywords?: Array<string> | undefined;
    lang?:
      | PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsLang
      | undefined;
    zoom?: number | undefined;
    lat?: string | undefined;
    lon?: string | undefined;
    fastMode?: boolean | undefined;
    radius?: number | undefined;
    depth?: number | undefined;
    email?: boolean | undefined;
    maxTime?: number | undefined;
    proxies?: Array<string> | undefined;
    updatedAt?: Date | undefined;
    deletedAt?: Date | undefined;
    leads?:
      | Array<
        PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsLeads
      >
      | undefined;
    url?: string | undefined;
  };

export const PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsOutputFormat =
  {
    OutputFormatUnspecified: "OUTPUT_FORMAT_UNSPECIFIED",
    OutputFormatJson: "OUTPUT_FORMAT_JSON",
    OutputFormatCsv: "OUTPUT_FORMAT_CSV",
    OutputFormatBigquery: "OUTPUT_FORMAT_BIGQUERY",
    OutputFormatPostgres: "OUTPUT_FORMAT_POSTGRES",
  } as const;
export type PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsOutputFormat =
  ClosedEnum<
    typeof PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsOutputFormat
  >;

export type PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsWorkflows =
  {
    id?: string | undefined;
    name?: string | undefined;
    cronExpression?: string | undefined;
    nextRunTime?: Date | undefined;
    lastRunTime?: Date | undefined;
    status?:
      | PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsStatus
      | undefined;
    retryCount?: number | undefined;
    maxRetries?: number | undefined;
    alertEmails?: string | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    deletedAt?: Date | undefined;
    jobs?:
      | Array<
        PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsJobs
      >
      | undefined;
    geoFencingRadius?: number | undefined;
    geoFencingLat?: number | undefined;
    geoFencingLon?: number | undefined;
    geoFencingZoomMin?: number | undefined;
    geoFencingZoomMax?: number | undefined;
    includeReviews?: boolean | undefined;
    includePhotos?: boolean | undefined;
    includeBusinessHours?: boolean | undefined;
    maxReviewsPerBusiness?: number | undefined;
    outputFormat?:
      | PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsOutputFormat
      | undefined;
    outputDestination?: string | undefined;
    dataRetention?: string | undefined;
    anonymizePii?: boolean | undefined;
    notificationSlackChannel?: string | undefined;
    notificationEmailGroup?: string | undefined;
    notificationNotifyOnStart?: boolean | undefined;
    notificationNotifyOnComplete?: boolean | undefined;
    notificationNotifyOnFailure?: boolean | undefined;
    contentFilterAllowedCountries?: Array<string> | undefined;
    contentFilterExcludedTypes?: Array<string> | undefined;
    contentFilterMinimumRating?: number | undefined;
    contentFilterMinimumReviews?: number | undefined;
    qosMaxConcurrentRequests?: number | undefined;
    qosMaxRetries?: number | undefined;
    qosRequestTimeout?: string | undefined;
    qosEnableJavascript?: boolean | undefined;
    respectRobotsTxt?: boolean | undefined;
    acceptTermsOfService?: boolean | undefined;
    userAgent?: string | undefined;
    searchTerms?: Array<string> | undefined;
    scheduledEntryId?: string | undefined;
  };

export const PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsRequestStatus =
  {
    BackgroundJobStatusUnspecified: "BACKGROUND_JOB_STATUS_UNSPECIFIED",
    BackgroundJobStatusQueued: "BACKGROUND_JOB_STATUS_QUEUED",
    BackgroundJobStatusInProgress: "BACKGROUND_JOB_STATUS_IN_PROGRESS",
    BackgroundJobStatusCompleted: "BACKGROUND_JOB_STATUS_COMPLETED",
    BackgroundJobStatusFailed: "BACKGROUND_JOB_STATUS_FAILED",
    BackgroundJobStatusCancelled: "BACKGROUND_JOB_STATUS_CANCELLED",
    BackgroundJobStatusTimedOut: "BACKGROUND_JOB_STATUS_TIMED_OUT",
  } as const;
export type PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsRequestStatus =
  ClosedEnum<
    typeof PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsRequestStatus
  >;

export const PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsLang =
  {
    LanguageUnspecified: "LANGUAGE_UNSPECIFIED",
    LanguageEnglish: "LANGUAGE_ENGLISH",
    LanguageSpanish: "LANGUAGE_SPANISH",
    LanguageFrench: "LANGUAGE_FRENCH",
    LanguageGerman: "LANGUAGE_GERMAN",
    LanguageItalian: "LANGUAGE_ITALIAN",
    LanguagePortuguese: "LANGUAGE_PORTUGUESE",
    LanguageDutch: "LANGUAGE_DUTCH",
    LanguageRussian: "LANGUAGE_RUSSIAN",
    LanguageChinese: "LANGUAGE_CHINESE",
    LanguageJapanese: "LANGUAGE_JAPANESE",
    LanguageKorean: "LANGUAGE_KOREAN",
    LanguageArabic: "LANGUAGE_ARABIC",
    LanguageHindi: "LANGUAGE_HINDI",
    LanguageGreek: "LANGUAGE_GREEK",
    LanguageTurkish: "LANGUAGE_TURKISH",
  } as const;
export type PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsLang =
  ClosedEnum<
    typeof PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsLang
  >;

export const PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsRequestDay =
  {
    DayOfWeekUnspecified: "DAY_OF_WEEK_UNSPECIFIED",
    DayOfWeekMonday: "DAY_OF_WEEK_MONDAY",
    DayOfWeekTuesday: "DAY_OF_WEEK_TUESDAY",
    DayOfWeekWednesday: "DAY_OF_WEEK_WEDNESDAY",
    DayOfWeekThursday: "DAY_OF_WEEK_THURSDAY",
    DayOfWeekFriday: "DAY_OF_WEEK_FRIDAY",
    DayOfWeekSaturday: "DAY_OF_WEEK_SATURDAY",
    DayOfWeekSunday: "DAY_OF_WEEK_SUNDAY",
  } as const;
export type PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsRequestDay =
  ClosedEnum<
    typeof PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsRequestDay
  >;

export type PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsRegularHours =
  {
    id?: string | undefined;
    day?:
      | PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsRequestDay
      | undefined;
    openTime?: string | undefined;
    closeTime?: string | undefined;
    closed?: boolean | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    deletedAt?: Date | undefined;
  };

export const PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsRequestRequestBodyDay =
  {
    DayOfWeekUnspecified: "DAY_OF_WEEK_UNSPECIFIED",
    DayOfWeekMonday: "DAY_OF_WEEK_MONDAY",
    DayOfWeekTuesday: "DAY_OF_WEEK_TUESDAY",
    DayOfWeekWednesday: "DAY_OF_WEEK_WEDNESDAY",
    DayOfWeekThursday: "DAY_OF_WEEK_THURSDAY",
    DayOfWeekFriday: "DAY_OF_WEEK_FRIDAY",
    DayOfWeekSaturday: "DAY_OF_WEEK_SATURDAY",
    DayOfWeekSunday: "DAY_OF_WEEK_SUNDAY",
  } as const;
export type PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsRequestRequestBodyDay =
  ClosedEnum<
    typeof PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsRequestRequestBodyDay
  >;

export type PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsSpecialHours =
  {
    id?: string | undefined;
    day?:
      | PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsRequestRequestBodyDay
      | undefined;
    openTime?: string | undefined;
    closeTime?: string | undefined;
    closed?: boolean | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    deletedAt?: Date | undefined;
  };

export type PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsReviews =
  {
    id?: string | undefined;
    author?: string | undefined;
    rating?: number | undefined;
    text?: string | undefined;
    time?: Date | undefined;
    language?: string | undefined;
    profilePhotoUrl?: string | undefined;
    reviewCount?: number | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    deletedAt?: Date | undefined;
  };

export const PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsRevenueRange =
  {
    RevenueRangeUnspecified: "REVENUE_RANGE_UNSPECIFIED",
    RevenueRangeUnder100K: "REVENUE_RANGE_UNDER_100K",
    RevenueRange100KTo1M: "REVENUE_RANGE_100K_TO_1M",
    RevenueRange1MTo10M: "REVENUE_RANGE_1M_TO_10M",
    RevenueRange10MTo50M: "REVENUE_RANGE_10M_TO_50M",
    RevenueRangeOver50M: "REVENUE_RANGE_OVER_50M",
  } as const;
export type PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsRevenueRange =
  ClosedEnum<
    typeof PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsRevenueRange
  >;

export const PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsEmployeeBenefits =
  {
    EmployeeBenefitUnspecified: "EMPLOYEE_BENEFIT_UNSPECIFIED",
    EmployeeBenefitHealthInsurance: "EMPLOYEE_BENEFIT_HEALTH_INSURANCE",
    EmployeeBenefitRetirementPlan: "EMPLOYEE_BENEFIT_RETIREMENT_PLAN",
    EmployeeBenefitPaidTimeOff: "EMPLOYEE_BENEFIT_PAID_TIME_OFF",
    EmployeeBenefitRemoteWork: "EMPLOYEE_BENEFIT_REMOTE_WORK",
  } as const;
export type PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsEmployeeBenefits =
  ClosedEnum<
    typeof PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsEmployeeBenefits
  >;

export type PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsLeads =
  {
    id?: string | undefined;
    name?: string | undefined;
    website?: string | undefined;
    phone?: string | undefined;
    address?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    country?: string | undefined;
    latitude?: number | undefined;
    longitude?: number | undefined;
    googleRating?: number | undefined;
    reviewCount?: number | undefined;
    industry?: string | undefined;
    employeeCount?: number | undefined;
    estimatedRevenue?: string | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    deletedAt?: Date | undefined;
    placeId?: string | undefined;
    googleMapsUrl?: string | undefined;
    businessStatus?: string | undefined;
    regularHours?:
      | Array<
        PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsRegularHours
      >
      | undefined;
    specialHours?:
      | Array<
        PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsSpecialHours
      >
      | undefined;
    photoReferences?: Array<string> | undefined;
    mainPhotoUrl?: string | undefined;
    reviews?:
      | Array<
        PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsReviews
      >
      | undefined;
    types?: Array<string> | undefined;
    amenities?: Array<string> | undefined;
    servesVegetarianFood?: boolean | undefined;
    outdoorSeating?: boolean | undefined;
    paymentMethods?: Array<string> | undefined;
    wheelchairAccessible?: boolean | undefined;
    parkingAvailable?: boolean | undefined;
    socialMedia?: { [k: string]: string } | undefined;
    ratingCategory?: string | undefined;
    rating?: number | undefined;
    count?: number | undefined;
    lastUpdated?: Date | undefined;
    dataSourceVersion?: string | undefined;
    scrapingSessionId?: string | undefined;
    alternatePhones?: Array<string> | undefined;
    contactPersonName?: string | undefined;
    contactPersonTitle?: string | undefined;
    contactEmail?: string | undefined;
    foundedYear?: number | undefined;
    businessType?: string | undefined;
    certifications?: Array<string> | undefined;
    licenseNumber?: string | undefined;
    revenueRange?:
      | PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsRevenueRange
      | undefined;
    fundingStage?: string | undefined;
    isPublicCompany?: boolean | undefined;
    websiteLoadSpeed?: number | undefined;
    hasSslCertificate?: boolean | undefined;
    cmsUsed?: string | undefined;
    ecommercePlatforms?: Array<string> | undefined;
    timezone?: string | undefined;
    neighborhood?: string | undefined;
    nearbyLandmarks?: Array<string> | undefined;
    transportationAccess?: string | undefined;
    employeeBenefits?:
      | Array<
        PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsEmployeeBenefits
      >
      | undefined;
    parentCompany?: string | undefined;
    subsidiaries?: Array<string> | undefined;
    isFranchise?: boolean | undefined;
    seoKeywords?: Array<string> | undefined;
    usesGoogleAds?: boolean | undefined;
    googleMyBusinessCategory?: string | undefined;
    naicsCode?: string | undefined;
    sicCode?: string | undefined;
    unspscCode?: string | undefined;
    isGreenCertified?: boolean | undefined;
    energySources?: Array<string> | undefined;
    sustainabilityRating?: string | undefined;
    recentAnnouncements?: Array<string> | undefined;
    lastProductLaunch?: Date | undefined;
    hasLitigationHistory?: boolean | undefined;
    exportControlStatus?: string | undefined;
  };

export type PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsScrapingJobs =
  {
    id?: string | undefined;
    priority?: number | undefined;
    payloadType?: string | undefined;
    payload?: string | undefined;
    createdAt?: Date | undefined;
    status?:
      | PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsRequestStatus
      | undefined;
    name?: string | undefined;
    keywords?: Array<string> | undefined;
    lang?:
      | PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsLang
      | undefined;
    zoom?: number | undefined;
    lat?: string | undefined;
    lon?: string | undefined;
    fastMode?: boolean | undefined;
    radius?: number | undefined;
    depth?: number | undefined;
    email?: boolean | undefined;
    maxTime?: number | undefined;
    proxies?: Array<string> | undefined;
    updatedAt?: Date | undefined;
    deletedAt?: Date | undefined;
    leads?:
      | Array<
        PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsLeads
      >
      | undefined;
    url?: string | undefined;
  };

export const PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsRequestRequestBodyStatus =
  {
    StatusUnspecified: "STATUS_UNSPECIFIED",
    StatusActive: "STATUS_ACTIVE",
    StatusSuspended: "STATUS_SUSPENDED",
    StatusPendingVerification: "STATUS_PENDING_VERIFICATION",
    StatusRevoked: "STATUS_REVOKED",
    StatusExpired: "STATUS_EXPIRED",
    StatusRateLimited: "STATUS_RATE_LIMITED",
    StatusPendingReview: "STATUS_PENDING_REVIEW",
    StatusDeprecated: "STATUS_DEPRECATED",
    StatusMaintenance: "STATUS_MAINTENANCE",
  } as const;
export type PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsRequestRequestBodyStatus =
  ClosedEnum<
    typeof PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsRequestRequestBodyStatus
  >;

export type PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsApiKeys =
  {
    id?: string | undefined;
    name?: string | undefined;
    keyHash?: string | undefined;
    keyPrefix?: string | undefined;
    scopes?: Array<string> | undefined;
    allowedIps?: Array<string> | undefined;
    allowedDomains?: Array<string> | undefined;
    allowedEnvironments?: Array<string> | undefined;
    isTestKey?: boolean | undefined;
    requestsPerSecond?: number | undefined;
    requestsPerDay?: number | undefined;
    concurrentRequests?: number | undefined;
    monthlyRequestQuota?: string | undefined;
    costPerRequest?: number | undefined;
    billingTier?: string | undefined;
    totalRequests?: string | undefined;
    totalErrors?: string | undefined;
    lastUsedAt?: Date | undefined;
    averageResponseTime?: number | undefined;
    endpointUsageJson?: string | undefined;
    errorRatesJson?: string | undefined;
    recentErrors?: string | undefined;
    successfulRequestsCount?: number | undefined;
    successRate?: number | undefined;
    status?:
      | PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsRequestRequestBodyStatus
      | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    expiresAt?: Date | undefined;
    deletedAt?: Date | undefined;
    lastRotatedAt?: Date | undefined;
    lastSecurityReviewAt?: Date | undefined;
    requiresClientSecret?: boolean | undefined;
    clientSecretHash?: string | undefined;
    enforceHttps?: boolean | undefined;
    enforceSigning?: boolean | undefined;
    allowedSignatureAlgorithms?: Array<string> | undefined;
    enforceMutualTls?: boolean | undefined;
    clientCertificateHash?: string | undefined;
    requireRequestSigning?: boolean | undefined;
    description?: string | undefined;
    metadataJson?: string | undefined;
    tags?: Array<string> | undefined;
    apiVersion?: string | undefined;
    supportedFeatures?: Array<string> | undefined;
    documentationUrl?: string | undefined;
    supportContact?: string | undefined;
    logAllRequests?: boolean | undefined;
    lastRotationReason?: string | undefined;
    lastRotationDate?: Date | undefined;
    rotationFrequencyDays?: number | undefined;
    complianceStandards?: Array<string> | undefined;
    requiresAuditLogging?: boolean | undefined;
    dataResidency?: string | undefined;
    approvedIntegrations?: Array<string> | undefined;
    alertEmails?: Array<string> | undefined;
    webhookUrl?: string | undefined;
    alertOnQuotaThreshold?: boolean | undefined;
    quotaAlertThreshold?: number | undefined;
    alertOnErrorSpike?: boolean | undefined;
    errorAlertThreshold?: number | undefined;
    monitoringIntegrations?: Array<string> | undefined;
    encrypted?: boolean | undefined;
    dataClassification?: string | undefined;
    maxUses?: number | undefined;
    rateLimit?: number | undefined;
  };

export const PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTriggerEvents =
  {
    TriggerEventUnspecified: "TRIGGER_EVENT_UNSPECIFIED",
    TriggerEventJobStarted: "TRIGGER_EVENT_JOB_STARTED",
    TriggerEventJobCompleted: "TRIGGER_EVENT_JOB_COMPLETED",
    TriggerEventJobFailed: "TRIGGER_EVENT_JOB_FAILED",
    TriggerEventLeadFound: "TRIGGER_EVENT_LEAD_FOUND",
    TriggerEventQuotaExceeded: "TRIGGER_EVENT_QUOTA_EXCEEDED",
    TriggerEventErrorThresholdReached: "TRIGGER_EVENT_ERROR_THRESHOLD_REACHED",
    TriggerEventRateLimitReached: "TRIGGER_EVENT_RATE_LIMIT_REACHED",
    TriggerEventDataValidationFailed: "TRIGGER_EVENT_DATA_VALIDATION_FAILED",
    TriggerEventNewProxyNeeded: "TRIGGER_EVENT_NEW_PROXY_NEEDED",
    TriggerEventScheduledMaintenance: "TRIGGER_EVENT_SCHEDULED_MAINTENANCE",
  } as const;
export type PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTriggerEvents =
  ClosedEnum<
    typeof PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTriggerEvents
  >;

export const PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsIncludedFields =
  {
    IncludedFieldUnspecified: "INCLUDED_FIELD_UNSPECIFIED",
    IncludedFieldName: "INCLUDED_FIELD_NAME",
    IncludedFieldWebsite: "INCLUDED_FIELD_WEBSITE",
    IncludedFieldPhone: "INCLUDED_FIELD_PHONE",
    IncludedFieldAddress: "INCLUDED_FIELD_ADDRESS",
    IncludedFieldLocation: "INCLUDED_FIELD_LOCATION",
    IncludedFieldCoordinates: "INCLUDED_FIELD_COORDINATES",
    IncludedFieldGoogleRating: "INCLUDED_FIELD_GOOGLE_RATING",
    IncludedFieldReviewCount: "INCLUDED_FIELD_REVIEW_COUNT",
    IncludedFieldReviews: "INCLUDED_FIELD_REVIEWS",
    IncludedFieldBusinessHours: "INCLUDED_FIELD_BUSINESS_HOURS",
    IncludedFieldBusinessStatus: "INCLUDED_FIELD_BUSINESS_STATUS",
    IncludedFieldPlaceId: "INCLUDED_FIELD_PLACE_ID",
    IncludedFieldGoogleMapsUrl: "INCLUDED_FIELD_GOOGLE_MAPS_URL",
    IncludedFieldPhotos: "INCLUDED_FIELD_PHOTOS",
    IncludedFieldMainPhoto: "INCLUDED_FIELD_MAIN_PHOTO",
    IncludedFieldBusinessTypes: "INCLUDED_FIELD_BUSINESS_TYPES",
    IncludedFieldAmenities: "INCLUDED_FIELD_AMENITIES",
    IncludedFieldPaymentMethods: "INCLUDED_FIELD_PAYMENT_METHODS",
    IncludedFieldSocialProfiles: "INCLUDED_FIELD_SOCIAL_PROFILES",
    IncludedFieldEmployeeCount: "INCLUDED_FIELD_EMPLOYEE_COUNT",
    IncludedFieldRevenueInfo: "INCLUDED_FIELD_REVENUE_INFO",
    IncludedFieldFoundedYear: "INCLUDED_FIELD_FOUNDED_YEAR",
    IncludedFieldCertifications: "INCLUDED_FIELD_CERTIFICATIONS",
    IncludedFieldNaicsCode: "INCLUDED_FIELD_NAICS_CODE",
    IncludedFieldSicCode: "INCLUDED_FIELD_SIC_CODE",
    IncludedFieldScrapingMetadata: "INCLUDED_FIELD_SCRAPING_METADATA",
    IncludedFieldComplianceInfo: "INCLUDED_FIELD_COMPLIANCE_INFO",
    IncludedFieldAlternatePhones: "INCLUDED_FIELD_ALTERNATE_PHONES",
    IncludedFieldContactPerson: "INCLUDED_FIELD_CONTACT_PERSON",
    IncludedFieldContactEmail: "INCLUDED_FIELD_CONTACT_EMAIL",
  } as const;
export type PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsIncludedFields =
  ClosedEnum<
    typeof PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsIncludedFields
  >;

export const PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsPayloadFormat =
  {
    PayloadFormatUnspecified: "PAYLOAD_FORMAT_UNSPECIFIED",
    PayloadFormatJson: "PAYLOAD_FORMAT_JSON",
    PayloadFormatXml: "PAYLOAD_FORMAT_XML",
    PayloadFormatFormData: "PAYLOAD_FORMAT_FORM_DATA",
    PayloadFormatProtobuf: "PAYLOAD_FORMAT_PROTOBUF",
    PayloadFormatYaml: "PAYLOAD_FORMAT_YAML",
  } as const;
export type PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsPayloadFormat =
  ClosedEnum<
    typeof PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsPayloadFormat
  >;

export type PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsMetadata =
  {};

export type PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsWebhooks =
  {
    id?: string | undefined;
    url?: string | undefined;
    authType?: string | undefined;
    authToken?: string | undefined;
    customHeaders?: { [k: string]: string } | undefined;
    maxRetries?: number | undefined;
    retryInterval?: string | undefined;
    triggerEvents?:
      | Array<
        PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTriggerEvents
      >
      | undefined;
    includedFields?:
      | Array<
        PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsIncludedFields
      >
      | undefined;
    includeFullResults?: boolean | undefined;
    payloadFormat?:
      | PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsPayloadFormat
      | undefined;
    verifySsl?: boolean | undefined;
    signingSecret?: string | undefined;
    rateLimit?: number | undefined;
    rateLimitInterval?: string | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    lastTriggeredAt?: Date | undefined;
    successfulCalls?: number | undefined;
    failedCalls?: number | undefined;
    metadata?:
      | PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsMetadata
      | undefined;
    webhookName?: string | undefined;
  };

export const PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsWorkspaceType =
  {
    WorkspaceTypeUnspecified: "WORKSPACE_TYPE_UNSPECIFIED",
    WorkspaceTypePersonal: "WORKSPACE_TYPE_PERSONAL",
    WorkspaceTypeTeam: "WORKSPACE_TYPE_TEAM",
    WorkspaceTypeEnterprise: "WORKSPACE_TYPE_ENTERPRISE",
  } as const;
export type PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsWorkspaceType =
  ClosedEnum<
    typeof PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsWorkspaceType
  >;

export type PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsWorkspaces =
  {
    id?: string | undefined;
    name?: string | undefined;
    industry?: string | undefined;
    domain?: string | undefined;
    gdprCompliant?: boolean | undefined;
    hipaaCompliant?: boolean | undefined;
    soc2Compliant?: boolean | undefined;
    storageQuota?: string | undefined;
    usedStorage?: string | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    deletedAt?: Date | undefined;
    workflows?:
      | Array<
        PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsWorkflows
      >
      | undefined;
    jobsRunThisMonth?: number | undefined;
    workspaceJobLimit?: number | undefined;
    dailyJobQuota?: number | undefined;
    activeScrapers?: number | undefined;
    totalLeadsCollected?: number | undefined;
    lastJobRun?: Date | undefined;
    scrapingJobs?:
      | Array<
        PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsScrapingJobs
      >
      | undefined;
    apiKeys?:
      | Array<
        PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsApiKeys
      >
      | undefined;
    webhooks?:
      | Array<
        PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsWebhooks
      >
      | undefined;
    workspaceType?:
      | PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsWorkspaceType
      | undefined;
    description?: string | undefined;
    metadata?: { [k: string]: string } | undefined;
    tags?: Array<string> | undefined;
    maxTeamMembers?: number | undefined;
    currentTeamMembers?: number | undefined;
    allowGuestAccess?: boolean | undefined;
    allowedEmailDomains?: Array<string> | undefined;
    exportFormats?: Array<string> | undefined;
    exportSchedule?: string | undefined;
    exportDestinations?: Array<string> | undefined;
    exportDestinationConfig?: { [k: string]: string } | undefined;
    compressExports?: boolean | undefined;
    compressionFormat?: string | undefined;
    salesforceEnabled?: boolean | undefined;
    salesforceConfig?: string | undefined;
    hubspotEnabled?: boolean | undefined;
    hubspotConfig?: string | undefined;
    zapierEnabled?: boolean | undefined;
    zapierWebhook?: string | undefined;
    activeIntegrations?: Array<string> | undefined;
    integrationSettings?: { [k: string]: string } | undefined;
  };

export type PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsSettings =
  {
    id?: string | undefined;
    emailNotifications?: boolean | undefined;
    slackNotifications?: boolean | undefined;
    defaultDataRetention?: string | undefined;
    autoPurgeEnabled?: boolean | undefined;
    require2fa?: boolean | undefined;
    sessionTimeout?: string | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    deletedAt?: Date | undefined;
  };

export type PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsAccounts =
  {
    id?: string | undefined;
    authPlatformUserId?: string | undefined;
    email?: string | undefined;
    deletedAt?: Date | undefined;
    createdAt?: Date | undefined;
    accountStatus?:
      | PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsAccountStatus
      | undefined;
    roles?:
      | Array<
        PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsRoles
      >
      | undefined;
    permissions?:
      | Array<
        PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsPermissions
      >
      | undefined;
    mfaEnabled?: boolean | undefined;
    lastLoginAt?: Date | undefined;
    timezone?:
      | PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTimezone
      | undefined;
    totalJobsRun?: number | undefined;
    monthlyJobLimit?: number | undefined;
    concurrentJobLimit?: number | undefined;
    workspaces?:
      | Array<
        PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsWorkspaces
      >
      | undefined;
    settings?:
      | PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsSettings
      | undefined;
  };

export const PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsRequestRequestBodyTenantStatus =
  {
    StatusUnspecified: "STATUS_UNSPECIFIED",
    StatusActive: "STATUS_ACTIVE",
    StatusSuspended: "STATUS_SUSPENDED",
    StatusPendingVerification: "STATUS_PENDING_VERIFICATION",
    StatusRevoked: "STATUS_REVOKED",
    StatusExpired: "STATUS_EXPIRED",
    StatusRateLimited: "STATUS_RATE_LIMITED",
    StatusPendingReview: "STATUS_PENDING_REVIEW",
    StatusDeprecated: "STATUS_DEPRECATED",
    StatusMaintenance: "STATUS_MAINTENANCE",
  } as const;
export type PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsRequestRequestBodyTenantStatus =
  ClosedEnum<
    typeof PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsRequestRequestBodyTenantStatus
  >;

export const PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsScopes =
  {
    TenantApiKeyScopeUnspecified: "TENANT_API_KEY_SCOPE_UNSPECIFIED",
    TenantApiKeyScopeReadJobs: "TENANT_API_KEY_SCOPE_READ_JOBS",
    TenantApiKeyScopeReadLeads: "TENANT_API_KEY_SCOPE_READ_LEADS",
    TenantApiKeyScopeReadWorkflows: "TENANT_API_KEY_SCOPE_READ_WORKFLOWS",
    TenantApiKeyScopeReadAnalytics: "TENANT_API_KEY_SCOPE_READ_ANALYTICS",
    TenantApiKeyScopeReadSettings: "TENANT_API_KEY_SCOPE_READ_SETTINGS",
    TenantApiKeyScopeWriteJobs: "TENANT_API_KEY_SCOPE_WRITE_JOBS",
    TenantApiKeyScopeWriteLeads: "TENANT_API_KEY_SCOPE_WRITE_LEADS",
    TenantApiKeyScopeWriteWorkflows: "TENANT_API_KEY_SCOPE_WRITE_WORKFLOWS",
    TenantApiKeyScopeWriteSettings: "TENANT_API_KEY_SCOPE_WRITE_SETTINGS",
    TenantApiKeyScopeDeleteJobs: "TENANT_API_KEY_SCOPE_DELETE_JOBS",
    TenantApiKeyScopeDeleteLeads: "TENANT_API_KEY_SCOPE_DELETE_LEADS",
    TenantApiKeyScopeDeleteWorkflows: "TENANT_API_KEY_SCOPE_DELETE_WORKFLOWS",
    TenantApiKeyScopeExportData: "TENANT_API_KEY_SCOPE_EXPORT_DATA",
    TenantApiKeyScopeManageKeys: "TENANT_API_KEY_SCOPE_MANAGE_KEYS",
    TenantApiKeyScopeBillingRead: "TENANT_API_KEY_SCOPE_BILLING_READ",
    TenantApiKeyScopeBillingWrite: "TENANT_API_KEY_SCOPE_BILLING_WRITE",
    TenantApiKeyScopeAdmin: "TENANT_API_KEY_SCOPE_ADMIN",
  } as const;
export type PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsScopes =
  ClosedEnum<
    typeof PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsScopes
  >;

export type PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsApiKeys =
  {
    id?: string | undefined;
    keyHash?: string | undefined;
    keyPrefix?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    status?:
      | PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsRequestRequestBodyTenantStatus
      | undefined;
    scopes?:
      | Array<
        PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsScopes
      >
      | undefined;
    maxUses?: number | undefined;
    allowedIps?: Array<string> | undefined;
    useCount?: number | undefined;
    expiresAt?: Date | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    deletedAt?: Date | undefined;
  };

export const PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsRequestRequestBodyTenantStatus1 =
  {
    StatusUnspecified: "STATUS_UNSPECIFIED",
    StatusActive: "STATUS_ACTIVE",
    StatusSuspended: "STATUS_SUSPENDED",
    StatusPendingVerification: "STATUS_PENDING_VERIFICATION",
    StatusRevoked: "STATUS_REVOKED",
    StatusExpired: "STATUS_EXPIRED",
    StatusRateLimited: "STATUS_RATE_LIMITED",
    StatusPendingReview: "STATUS_PENDING_REVIEW",
    StatusDeprecated: "STATUS_DEPRECATED",
    StatusMaintenance: "STATUS_MAINTENANCE",
  } as const;
export type PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsRequestRequestBodyTenantStatus1 =
  ClosedEnum<
    typeof PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsRequestRequestBodyTenantStatus1
  >;

export type PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenant =
  {
    id?: string | undefined;
    name?: string | undefined;
    displayName?: string | undefined;
    description?: string | undefined;
    apiBaseUrl?: string | undefined;
    environmentVariables?: { [k: string]: string } | undefined;
    allowedOrigins?: Array<string> | undefined;
    storageQuota?: string | undefined;
    monthlyRequestLimit?: string | undefined;
    maxConcurrentJobs?: number | undefined;
    enableCaching?: boolean | undefined;
    enableRateLimiting?: boolean | undefined;
    enableRequestLogging?: boolean | undefined;
    accounts?:
      | Array<
        PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsAccounts
      >
      | undefined;
    apiKeys?:
      | Array<
        PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsApiKeys
      >
      | undefined;
    totalRequests?: string | undefined;
    totalStorageUsed?: string | undefined;
    averageResponseTime?: number | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    deletedAt?: Date | undefined;
    status?:
      | PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsRequestRequestBodyTenantStatus1
      | undefined;
  };

export type PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsRequestBody =
  {
    tenant?:
      | PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenant
      | undefined;
  };

export type PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsRequest =
  {
    organizationId: string;
    requestBody:
      PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsRequestBody;
  };

/**
 * Creates a new tenant in the system
 */
export type PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsResponseBody =
  {
    tenantId?: string | undefined;
  };

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsAccountStatus$inboundSchema:
  z.ZodNativeEnum<
    typeof PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsAccountStatus
  > = z.nativeEnum(
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsAccountStatus,
  );

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsAccountStatus$outboundSchema:
  z.ZodNativeEnum<
    typeof PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsAccountStatus
  > =
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsAccountStatus$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsAccountStatus$ {
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsAccountStatus$inboundSchema` instead. */
  export const inboundSchema =
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsAccountStatus$inboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsAccountStatus$outboundSchema` instead. */
  export const outboundSchema =
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsAccountStatus$outboundSchema;
}

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsRoles$inboundSchema:
  z.ZodNativeEnum<
    typeof PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsRoles
  > = z.nativeEnum(
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsRoles,
  );

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsRoles$outboundSchema:
  z.ZodNativeEnum<
    typeof PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsRoles
  > =
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsRoles$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsRoles$ {
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsRoles$inboundSchema` instead. */
  export const inboundSchema =
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsRoles$inboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsRoles$outboundSchema` instead. */
  export const outboundSchema =
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsRoles$outboundSchema;
}

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsPermissions$inboundSchema:
  z.ZodNativeEnum<
    typeof PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsPermissions
  > = z.nativeEnum(
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsPermissions,
  );

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsPermissions$outboundSchema:
  z.ZodNativeEnum<
    typeof PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsPermissions
  > =
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsPermissions$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsPermissions$ {
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsPermissions$inboundSchema` instead. */
  export const inboundSchema =
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsPermissions$inboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsPermissions$outboundSchema` instead. */
  export const outboundSchema =
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsPermissions$outboundSchema;
}

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTimezone$inboundSchema:
  z.ZodNativeEnum<
    typeof PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTimezone
  > = z.nativeEnum(
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTimezone,
  );

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTimezone$outboundSchema:
  z.ZodNativeEnum<
    typeof PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTimezone
  > =
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTimezone$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTimezone$ {
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTimezone$inboundSchema` instead. */
  export const inboundSchema =
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTimezone$inboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTimezone$outboundSchema` instead. */
  export const outboundSchema =
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTimezone$outboundSchema;
}

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsStatus$inboundSchema:
  z.ZodNativeEnum<
    typeof PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsStatus
  > = z.nativeEnum(
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsStatus,
  );

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsStatus$outboundSchema:
  z.ZodNativeEnum<
    typeof PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsStatus
  > =
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsStatus$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsStatus$ {
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsStatus$inboundSchema` instead. */
  export const inboundSchema =
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsStatus$inboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsStatus$outboundSchema` instead. */
  export const outboundSchema =
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsStatus$outboundSchema;
}

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsStatus$inboundSchema:
  z.ZodNativeEnum<
    typeof PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsStatus
  > = z.nativeEnum(
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsStatus,
  );

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsStatus$outboundSchema:
  z.ZodNativeEnum<
    typeof PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsStatus
  > =
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsStatus$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsStatus$ {
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsStatus$inboundSchema` instead. */
  export const inboundSchema =
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsStatus$inboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsStatus$outboundSchema` instead. */
  export const outboundSchema =
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsStatus$outboundSchema;
}

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsLang$inboundSchema:
  z.ZodNativeEnum<
    typeof PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsLang
  > = z.nativeEnum(
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsLang,
  );

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsLang$outboundSchema:
  z.ZodNativeEnum<
    typeof PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsLang
  > =
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsLang$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsLang$ {
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsLang$inboundSchema` instead. */
  export const inboundSchema =
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsLang$inboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsLang$outboundSchema` instead. */
  export const outboundSchema =
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsLang$outboundSchema;
}

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsDay$inboundSchema:
  z.ZodNativeEnum<
    typeof PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsDay
  > = z.nativeEnum(
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsDay,
  );

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsDay$outboundSchema:
  z.ZodNativeEnum<
    typeof PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsDay
  > =
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsDay$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsDay$ {
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsDay$inboundSchema` instead. */
  export const inboundSchema =
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsDay$inboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsDay$outboundSchema` instead. */
  export const outboundSchema =
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsDay$outboundSchema;
}

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsRegularHours$inboundSchema:
  z.ZodType<
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsRegularHours,
    z.ZodTypeDef,
    unknown
  > = z.object({
    id: z.string().optional(),
    day:
      PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsDay$inboundSchema
        .default("DAY_OF_WEEK_UNSPECIFIED"),
    openTime: z.string().optional(),
    closeTime: z.string().optional(),
    closed: z.boolean().optional(),
    createdAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    updatedAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    deletedAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
  });

/** @internal */
export type PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsRegularHours$Outbound =
  {
    id?: string | undefined;
    day: string;
    openTime?: string | undefined;
    closeTime?: string | undefined;
    closed?: boolean | undefined;
    createdAt?: string | undefined;
    updatedAt?: string | undefined;
    deletedAt?: string | undefined;
  };

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsRegularHours$outboundSchema:
  z.ZodType<
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsRegularHours$Outbound,
    z.ZodTypeDef,
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsRegularHours
  > = z.object({
    id: z.string().optional(),
    day:
      PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsDay$outboundSchema
        .default("DAY_OF_WEEK_UNSPECIFIED"),
    openTime: z.string().optional(),
    closeTime: z.string().optional(),
    closed: z.boolean().optional(),
    createdAt: z.date().transform(v => v.toISOString()).optional(),
    updatedAt: z.date().transform(v => v.toISOString()).optional(),
    deletedAt: z.date().transform(v => v.toISOString()).optional(),
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsRegularHours$ {
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsRegularHours$inboundSchema` instead. */
  export const inboundSchema =
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsRegularHours$inboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsRegularHours$outboundSchema` instead. */
  export const outboundSchema =
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsRegularHours$outboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsRegularHours$Outbound` instead. */
  export type Outbound =
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsRegularHours$Outbound;
}

export function postApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsRegularHoursToJSON(
  postApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsRegularHours:
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsRegularHours,
): string {
  return JSON.stringify(
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsRegularHours$outboundSchema
      .parse(
        postApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsRegularHours,
      ),
  );
}

export function postApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsRegularHoursFromJSON(
  jsonString: string,
): SafeParseResult<
  PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsRegularHours,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsRegularHours$inboundSchema
        .parse(JSON.parse(x)),
    `Failed to parse 'PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsRegularHours' from JSON`,
  );
}

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsDay$inboundSchema:
  z.ZodNativeEnum<
    typeof PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsDay
  > = z.nativeEnum(
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsDay,
  );

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsDay$outboundSchema:
  z.ZodNativeEnum<
    typeof PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsDay
  > =
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsDay$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsDay$ {
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsDay$inboundSchema` instead. */
  export const inboundSchema =
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsDay$inboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsDay$outboundSchema` instead. */
  export const outboundSchema =
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsDay$outboundSchema;
}

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsSpecialHours$inboundSchema:
  z.ZodType<
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsSpecialHours,
    z.ZodTypeDef,
    unknown
  > = z.object({
    id: z.string().optional(),
    day:
      PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsDay$inboundSchema
        .default("DAY_OF_WEEK_UNSPECIFIED"),
    openTime: z.string().optional(),
    closeTime: z.string().optional(),
    closed: z.boolean().optional(),
    createdAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    updatedAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    deletedAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
  });

/** @internal */
export type PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsSpecialHours$Outbound =
  {
    id?: string | undefined;
    day: string;
    openTime?: string | undefined;
    closeTime?: string | undefined;
    closed?: boolean | undefined;
    createdAt?: string | undefined;
    updatedAt?: string | undefined;
    deletedAt?: string | undefined;
  };

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsSpecialHours$outboundSchema:
  z.ZodType<
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsSpecialHours$Outbound,
    z.ZodTypeDef,
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsSpecialHours
  > = z.object({
    id: z.string().optional(),
    day:
      PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsDay$outboundSchema
        .default("DAY_OF_WEEK_UNSPECIFIED"),
    openTime: z.string().optional(),
    closeTime: z.string().optional(),
    closed: z.boolean().optional(),
    createdAt: z.date().transform(v => v.toISOString()).optional(),
    updatedAt: z.date().transform(v => v.toISOString()).optional(),
    deletedAt: z.date().transform(v => v.toISOString()).optional(),
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsSpecialHours$ {
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsSpecialHours$inboundSchema` instead. */
  export const inboundSchema =
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsSpecialHours$inboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsSpecialHours$outboundSchema` instead. */
  export const outboundSchema =
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsSpecialHours$outboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsSpecialHours$Outbound` instead. */
  export type Outbound =
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsSpecialHours$Outbound;
}

export function postApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsSpecialHoursToJSON(
  postApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsSpecialHours:
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsSpecialHours,
): string {
  return JSON.stringify(
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsSpecialHours$outboundSchema
      .parse(
        postApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsSpecialHours,
      ),
  );
}

export function postApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsSpecialHoursFromJSON(
  jsonString: string,
): SafeParseResult<
  PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsSpecialHours,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsSpecialHours$inboundSchema
        .parse(JSON.parse(x)),
    `Failed to parse 'PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsSpecialHours' from JSON`,
  );
}

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsReviews$inboundSchema:
  z.ZodType<
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsReviews,
    z.ZodTypeDef,
    unknown
  > = z.object({
    id: z.string().optional(),
    author: z.string().optional(),
    rating: z.number().optional(),
    text: z.string().optional(),
    time: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    language: z.string().optional(),
    profilePhotoUrl: z.string().optional(),
    reviewCount: z.number().int().optional(),
    createdAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    updatedAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    deletedAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
  });

/** @internal */
export type PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsReviews$Outbound =
  {
    id?: string | undefined;
    author?: string | undefined;
    rating?: number | undefined;
    text?: string | undefined;
    time?: string | undefined;
    language?: string | undefined;
    profilePhotoUrl?: string | undefined;
    reviewCount?: number | undefined;
    createdAt?: string | undefined;
    updatedAt?: string | undefined;
    deletedAt?: string | undefined;
  };

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsReviews$outboundSchema:
  z.ZodType<
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsReviews$Outbound,
    z.ZodTypeDef,
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsReviews
  > = z.object({
    id: z.string().optional(),
    author: z.string().optional(),
    rating: z.number().optional(),
    text: z.string().optional(),
    time: z.date().transform(v => v.toISOString()).optional(),
    language: z.string().optional(),
    profilePhotoUrl: z.string().optional(),
    reviewCount: z.number().int().optional(),
    createdAt: z.date().transform(v => v.toISOString()).optional(),
    updatedAt: z.date().transform(v => v.toISOString()).optional(),
    deletedAt: z.date().transform(v => v.toISOString()).optional(),
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsReviews$ {
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsReviews$inboundSchema` instead. */
  export const inboundSchema =
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsReviews$inboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsReviews$outboundSchema` instead. */
  export const outboundSchema =
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsReviews$outboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsReviews$Outbound` instead. */
  export type Outbound =
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsReviews$Outbound;
}

export function postApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsReviewsToJSON(
  postApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsReviews:
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsReviews,
): string {
  return JSON.stringify(
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsReviews$outboundSchema
      .parse(
        postApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsReviews,
      ),
  );
}

export function postApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsReviewsFromJSON(
  jsonString: string,
): SafeParseResult<
  PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsReviews,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsReviews$inboundSchema
        .parse(JSON.parse(x)),
    `Failed to parse 'PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsReviews' from JSON`,
  );
}

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsRevenueRange$inboundSchema:
  z.ZodNativeEnum<
    typeof PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsRevenueRange
  > = z.nativeEnum(
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsRevenueRange,
  );

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsRevenueRange$outboundSchema:
  z.ZodNativeEnum<
    typeof PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsRevenueRange
  > =
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsRevenueRange$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsRevenueRange$ {
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsRevenueRange$inboundSchema` instead. */
  export const inboundSchema =
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsRevenueRange$inboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsRevenueRange$outboundSchema` instead. */
  export const outboundSchema =
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsRevenueRange$outboundSchema;
}

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsEmployeeBenefits$inboundSchema:
  z.ZodNativeEnum<
    typeof PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsEmployeeBenefits
  > = z.nativeEnum(
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsEmployeeBenefits,
  );

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsEmployeeBenefits$outboundSchema:
  z.ZodNativeEnum<
    typeof PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsEmployeeBenefits
  > =
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsEmployeeBenefits$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsEmployeeBenefits$ {
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsEmployeeBenefits$inboundSchema` instead. */
  export const inboundSchema =
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsEmployeeBenefits$inboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsEmployeeBenefits$outboundSchema` instead. */
  export const outboundSchema =
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsEmployeeBenefits$outboundSchema;
}

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsLeads$inboundSchema:
  z.ZodType<
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsLeads,
    z.ZodTypeDef,
    unknown
  > = z.object({
    id: z.string().optional(),
    name: z.string().optional(),
    website: z.string().optional(),
    phone: z.string().optional(),
    address: z.string().optional(),
    city: z.string().optional(),
    state: z.string().optional(),
    country: z.string().optional(),
    latitude: z.number().optional(),
    longitude: z.number().optional(),
    googleRating: z.number().optional(),
    reviewCount: z.number().int().optional(),
    industry: z.string().optional(),
    employeeCount: z.number().int().optional(),
    estimatedRevenue: z.string().optional(),
    createdAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    updatedAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    deletedAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    placeId: z.string().optional(),
    googleMapsUrl: z.string().optional(),
    businessStatus: z.string().optional(),
    regularHours: z.array(
      z.lazy(() =>
        PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsRegularHours$inboundSchema
      ),
    ).optional(),
    specialHours: z.array(
      z.lazy(() =>
        PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsSpecialHours$inboundSchema
      ),
    ).optional(),
    photoReferences: z.array(z.string()).optional(),
    mainPhotoUrl: z.string().optional(),
    reviews: z.array(
      z.lazy(() =>
        PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsReviews$inboundSchema
      ),
    ).optional(),
    types: z.array(z.string()).optional(),
    amenities: z.array(z.string()).optional(),
    servesVegetarianFood: z.boolean().optional(),
    outdoorSeating: z.boolean().optional(),
    paymentMethods: z.array(z.string()).optional(),
    wheelchairAccessible: z.boolean().optional(),
    parkingAvailable: z.boolean().optional(),
    socialMedia: z.record(z.string()).optional(),
    ratingCategory: z.string().optional(),
    rating: z.number().optional(),
    count: z.number().int().optional(),
    lastUpdated: z.string().datetime({ offset: true }).transform(v =>
      new Date(v)
    ).optional(),
    dataSourceVersion: z.string().optional(),
    scrapingSessionId: z.string().optional(),
    alternatePhones: z.array(z.string()).optional(),
    contactPersonName: z.string().optional(),
    contactPersonTitle: z.string().optional(),
    contactEmail: z.string().optional(),
    foundedYear: z.number().int().optional(),
    businessType: z.string().optional(),
    certifications: z.array(z.string()).optional(),
    licenseNumber: z.string().optional(),
    revenueRange:
      PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsRevenueRange$inboundSchema
        .default("REVENUE_RANGE_UNSPECIFIED"),
    fundingStage: z.string().optional(),
    isPublicCompany: z.boolean().optional(),
    websiteLoadSpeed: z.number().optional(),
    hasSslCertificate: z.boolean().optional(),
    cmsUsed: z.string().optional(),
    ecommercePlatforms: z.array(z.string()).optional(),
    timezone: z.string().optional(),
    neighborhood: z.string().optional(),
    nearbyLandmarks: z.array(z.string()).optional(),
    transportationAccess: z.string().optional(),
    employeeBenefits: z.array(
      PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsEmployeeBenefits$inboundSchema,
    ).optional(),
    parentCompany: z.string().optional(),
    subsidiaries: z.array(z.string()).optional(),
    isFranchise: z.boolean().optional(),
    seoKeywords: z.array(z.string()).optional(),
    usesGoogleAds: z.boolean().optional(),
    googleMyBusinessCategory: z.string().optional(),
    naicsCode: z.string().optional(),
    sicCode: z.string().optional(),
    unspscCode: z.string().optional(),
    isGreenCertified: z.boolean().optional(),
    energySources: z.array(z.string()).optional(),
    sustainabilityRating: z.string().optional(),
    recentAnnouncements: z.array(z.string()).optional(),
    lastProductLaunch: z.string().datetime({ offset: true }).transform(v =>
      new Date(v)
    ).optional(),
    hasLitigationHistory: z.boolean().optional(),
    exportControlStatus: z.string().optional(),
  });

/** @internal */
export type PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsLeads$Outbound =
  {
    id?: string | undefined;
    name?: string | undefined;
    website?: string | undefined;
    phone?: string | undefined;
    address?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    country?: string | undefined;
    latitude?: number | undefined;
    longitude?: number | undefined;
    googleRating?: number | undefined;
    reviewCount?: number | undefined;
    industry?: string | undefined;
    employeeCount?: number | undefined;
    estimatedRevenue?: string | undefined;
    createdAt?: string | undefined;
    updatedAt?: string | undefined;
    deletedAt?: string | undefined;
    placeId?: string | undefined;
    googleMapsUrl?: string | undefined;
    businessStatus?: string | undefined;
    regularHours?:
      | Array<
        PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsRegularHours$Outbound
      >
      | undefined;
    specialHours?:
      | Array<
        PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsSpecialHours$Outbound
      >
      | undefined;
    photoReferences?: Array<string> | undefined;
    mainPhotoUrl?: string | undefined;
    reviews?:
      | Array<
        PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsReviews$Outbound
      >
      | undefined;
    types?: Array<string> | undefined;
    amenities?: Array<string> | undefined;
    servesVegetarianFood?: boolean | undefined;
    outdoorSeating?: boolean | undefined;
    paymentMethods?: Array<string> | undefined;
    wheelchairAccessible?: boolean | undefined;
    parkingAvailable?: boolean | undefined;
    socialMedia?: { [k: string]: string } | undefined;
    ratingCategory?: string | undefined;
    rating?: number | undefined;
    count?: number | undefined;
    lastUpdated?: string | undefined;
    dataSourceVersion?: string | undefined;
    scrapingSessionId?: string | undefined;
    alternatePhones?: Array<string> | undefined;
    contactPersonName?: string | undefined;
    contactPersonTitle?: string | undefined;
    contactEmail?: string | undefined;
    foundedYear?: number | undefined;
    businessType?: string | undefined;
    certifications?: Array<string> | undefined;
    licenseNumber?: string | undefined;
    revenueRange: string;
    fundingStage?: string | undefined;
    isPublicCompany?: boolean | undefined;
    websiteLoadSpeed?: number | undefined;
    hasSslCertificate?: boolean | undefined;
    cmsUsed?: string | undefined;
    ecommercePlatforms?: Array<string> | undefined;
    timezone?: string | undefined;
    neighborhood?: string | undefined;
    nearbyLandmarks?: Array<string> | undefined;
    transportationAccess?: string | undefined;
    employeeBenefits?: Array<string> | undefined;
    parentCompany?: string | undefined;
    subsidiaries?: Array<string> | undefined;
    isFranchise?: boolean | undefined;
    seoKeywords?: Array<string> | undefined;
    usesGoogleAds?: boolean | undefined;
    googleMyBusinessCategory?: string | undefined;
    naicsCode?: string | undefined;
    sicCode?: string | undefined;
    unspscCode?: string | undefined;
    isGreenCertified?: boolean | undefined;
    energySources?: Array<string> | undefined;
    sustainabilityRating?: string | undefined;
    recentAnnouncements?: Array<string> | undefined;
    lastProductLaunch?: string | undefined;
    hasLitigationHistory?: boolean | undefined;
    exportControlStatus?: string | undefined;
  };

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsLeads$outboundSchema:
  z.ZodType<
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsLeads$Outbound,
    z.ZodTypeDef,
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsLeads
  > = z.object({
    id: z.string().optional(),
    name: z.string().optional(),
    website: z.string().optional(),
    phone: z.string().optional(),
    address: z.string().optional(),
    city: z.string().optional(),
    state: z.string().optional(),
    country: z.string().optional(),
    latitude: z.number().optional(),
    longitude: z.number().optional(),
    googleRating: z.number().optional(),
    reviewCount: z.number().int().optional(),
    industry: z.string().optional(),
    employeeCount: z.number().int().optional(),
    estimatedRevenue: z.string().optional(),
    createdAt: z.date().transform(v => v.toISOString()).optional(),
    updatedAt: z.date().transform(v => v.toISOString()).optional(),
    deletedAt: z.date().transform(v => v.toISOString()).optional(),
    placeId: z.string().optional(),
    googleMapsUrl: z.string().optional(),
    businessStatus: z.string().optional(),
    regularHours: z.array(
      z.lazy(() =>
        PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsRegularHours$outboundSchema
      ),
    ).optional(),
    specialHours: z.array(
      z.lazy(() =>
        PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsSpecialHours$outboundSchema
      ),
    ).optional(),
    photoReferences: z.array(z.string()).optional(),
    mainPhotoUrl: z.string().optional(),
    reviews: z.array(
      z.lazy(() =>
        PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsReviews$outboundSchema
      ),
    ).optional(),
    types: z.array(z.string()).optional(),
    amenities: z.array(z.string()).optional(),
    servesVegetarianFood: z.boolean().optional(),
    outdoorSeating: z.boolean().optional(),
    paymentMethods: z.array(z.string()).optional(),
    wheelchairAccessible: z.boolean().optional(),
    parkingAvailable: z.boolean().optional(),
    socialMedia: z.record(z.string()).optional(),
    ratingCategory: z.string().optional(),
    rating: z.number().optional(),
    count: z.number().int().optional(),
    lastUpdated: z.date().transform(v => v.toISOString()).optional(),
    dataSourceVersion: z.string().optional(),
    scrapingSessionId: z.string().optional(),
    alternatePhones: z.array(z.string()).optional(),
    contactPersonName: z.string().optional(),
    contactPersonTitle: z.string().optional(),
    contactEmail: z.string().optional(),
    foundedYear: z.number().int().optional(),
    businessType: z.string().optional(),
    certifications: z.array(z.string()).optional(),
    licenseNumber: z.string().optional(),
    revenueRange:
      PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsRevenueRange$outboundSchema
        .default("REVENUE_RANGE_UNSPECIFIED"),
    fundingStage: z.string().optional(),
    isPublicCompany: z.boolean().optional(),
    websiteLoadSpeed: z.number().optional(),
    hasSslCertificate: z.boolean().optional(),
    cmsUsed: z.string().optional(),
    ecommercePlatforms: z.array(z.string()).optional(),
    timezone: z.string().optional(),
    neighborhood: z.string().optional(),
    nearbyLandmarks: z.array(z.string()).optional(),
    transportationAccess: z.string().optional(),
    employeeBenefits: z.array(
      PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsEmployeeBenefits$outboundSchema,
    ).optional(),
    parentCompany: z.string().optional(),
    subsidiaries: z.array(z.string()).optional(),
    isFranchise: z.boolean().optional(),
    seoKeywords: z.array(z.string()).optional(),
    usesGoogleAds: z.boolean().optional(),
    googleMyBusinessCategory: z.string().optional(),
    naicsCode: z.string().optional(),
    sicCode: z.string().optional(),
    unspscCode: z.string().optional(),
    isGreenCertified: z.boolean().optional(),
    energySources: z.array(z.string()).optional(),
    sustainabilityRating: z.string().optional(),
    recentAnnouncements: z.array(z.string()).optional(),
    lastProductLaunch: z.date().transform(v => v.toISOString()).optional(),
    hasLitigationHistory: z.boolean().optional(),
    exportControlStatus: z.string().optional(),
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsLeads$ {
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsLeads$inboundSchema` instead. */
  export const inboundSchema =
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsLeads$inboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsLeads$outboundSchema` instead. */
  export const outboundSchema =
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsLeads$outboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsLeads$Outbound` instead. */
  export type Outbound =
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsLeads$Outbound;
}

export function postApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsLeadsToJSON(
  postApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsLeads:
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsLeads,
): string {
  return JSON.stringify(
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsLeads$outboundSchema
      .parse(
        postApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsLeads,
      ),
  );
}

export function postApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsLeadsFromJSON(
  jsonString: string,
): SafeParseResult<
  PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsLeads,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsLeads$inboundSchema
        .parse(JSON.parse(x)),
    `Failed to parse 'PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsLeads' from JSON`,
  );
}

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsJobs$inboundSchema:
  z.ZodType<
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsJobs,
    z.ZodTypeDef,
    unknown
  > = z.object({
    id: z.string().optional(),
    priority: z.number().int().optional(),
    payloadType: z.string().optional(),
    payload: z.string().optional(),
    createdAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    status:
      PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsStatus$inboundSchema
        .default("BACKGROUND_JOB_STATUS_UNSPECIFIED"),
    name: z.string().optional(),
    keywords: z.array(z.string()).optional(),
    lang:
      PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsLang$inboundSchema
        .default("LANGUAGE_UNSPECIFIED"),
    zoom: z.number().int().optional(),
    lat: z.string().optional(),
    lon: z.string().optional(),
    fastMode: z.boolean().optional(),
    radius: z.number().int().optional(),
    depth: z.number().int().optional(),
    email: z.boolean().optional(),
    maxTime: z.number().int().optional(),
    proxies: z.array(z.string()).optional(),
    updatedAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    deletedAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    leads: z.array(
      z.lazy(() =>
        PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsLeads$inboundSchema
      ),
    ).optional(),
    url: z.string().optional(),
  });

/** @internal */
export type PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsJobs$Outbound =
  {
    id?: string | undefined;
    priority?: number | undefined;
    payloadType?: string | undefined;
    payload?: string | undefined;
    createdAt?: string | undefined;
    status: string;
    name?: string | undefined;
    keywords?: Array<string> | undefined;
    lang: string;
    zoom?: number | undefined;
    lat?: string | undefined;
    lon?: string | undefined;
    fastMode?: boolean | undefined;
    radius?: number | undefined;
    depth?: number | undefined;
    email?: boolean | undefined;
    maxTime?: number | undefined;
    proxies?: Array<string> | undefined;
    updatedAt?: string | undefined;
    deletedAt?: string | undefined;
    leads?:
      | Array<
        PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsLeads$Outbound
      >
      | undefined;
    url?: string | undefined;
  };

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsJobs$outboundSchema:
  z.ZodType<
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsJobs$Outbound,
    z.ZodTypeDef,
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsJobs
  > = z.object({
    id: z.string().optional(),
    priority: z.number().int().optional(),
    payloadType: z.string().optional(),
    payload: z.string().optional(),
    createdAt: z.date().transform(v => v.toISOString()).optional(),
    status:
      PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsStatus$outboundSchema
        .default("BACKGROUND_JOB_STATUS_UNSPECIFIED"),
    name: z.string().optional(),
    keywords: z.array(z.string()).optional(),
    lang:
      PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsLang$outboundSchema
        .default("LANGUAGE_UNSPECIFIED"),
    zoom: z.number().int().optional(),
    lat: z.string().optional(),
    lon: z.string().optional(),
    fastMode: z.boolean().optional(),
    radius: z.number().int().optional(),
    depth: z.number().int().optional(),
    email: z.boolean().optional(),
    maxTime: z.number().int().optional(),
    proxies: z.array(z.string()).optional(),
    updatedAt: z.date().transform(v => v.toISOString()).optional(),
    deletedAt: z.date().transform(v => v.toISOString()).optional(),
    leads: z.array(
      z.lazy(() =>
        PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsLeads$outboundSchema
      ),
    ).optional(),
    url: z.string().optional(),
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsJobs$ {
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsJobs$inboundSchema` instead. */
  export const inboundSchema =
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsJobs$inboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsJobs$outboundSchema` instead. */
  export const outboundSchema =
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsJobs$outboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsJobs$Outbound` instead. */
  export type Outbound =
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsJobs$Outbound;
}

export function postApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsJobsToJSON(
  postApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsJobs:
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsJobs,
): string {
  return JSON.stringify(
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsJobs$outboundSchema
      .parse(
        postApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsJobs,
      ),
  );
}

export function postApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsJobsFromJSON(
  jsonString: string,
): SafeParseResult<
  PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsJobs,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsJobs$inboundSchema
        .parse(JSON.parse(x)),
    `Failed to parse 'PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsJobs' from JSON`,
  );
}

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsOutputFormat$inboundSchema:
  z.ZodNativeEnum<
    typeof PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsOutputFormat
  > = z.nativeEnum(
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsOutputFormat,
  );

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsOutputFormat$outboundSchema:
  z.ZodNativeEnum<
    typeof PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsOutputFormat
  > =
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsOutputFormat$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsOutputFormat$ {
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsOutputFormat$inboundSchema` instead. */
  export const inboundSchema =
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsOutputFormat$inboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsOutputFormat$outboundSchema` instead. */
  export const outboundSchema =
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsOutputFormat$outboundSchema;
}

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsWorkflows$inboundSchema:
  z.ZodType<
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsWorkflows,
    z.ZodTypeDef,
    unknown
  > = z.object({
    id: z.string().optional(),
    name: z.string().optional(),
    cronExpression: z.string().optional(),
    nextRunTime: z.string().datetime({ offset: true }).transform(v =>
      new Date(v)
    ).optional(),
    lastRunTime: z.string().datetime({ offset: true }).transform(v =>
      new Date(v)
    ).optional(),
    status:
      PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsStatus$inboundSchema
        .default("WORKFLOW_STATUS_UNSPECIFIED"),
    retryCount: z.number().int().optional(),
    maxRetries: z.number().int().optional(),
    alertEmails: z.string().optional(),
    createdAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    updatedAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    deletedAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    jobs: z.array(
      z.lazy(() =>
        PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsJobs$inboundSchema
      ),
    ).optional(),
    geoFencingRadius: z.number().optional(),
    geoFencingLat: z.number().optional(),
    geoFencingLon: z.number().optional(),
    geoFencingZoomMin: z.number().int().optional(),
    geoFencingZoomMax: z.number().int().optional(),
    includeReviews: z.boolean().optional(),
    includePhotos: z.boolean().optional(),
    includeBusinessHours: z.boolean().optional(),
    maxReviewsPerBusiness: z.number().int().optional(),
    outputFormat:
      PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsOutputFormat$inboundSchema
        .default("OUTPUT_FORMAT_UNSPECIFIED"),
    outputDestination: z.string().optional(),
    dataRetention: z.string().optional(),
    anonymizePii: z.boolean().optional(),
    notificationSlackChannel: z.string().optional(),
    notificationEmailGroup: z.string().optional(),
    notificationNotifyOnStart: z.boolean().optional(),
    notificationNotifyOnComplete: z.boolean().optional(),
    notificationNotifyOnFailure: z.boolean().optional(),
    contentFilterAllowedCountries: z.array(z.string()).optional(),
    contentFilterExcludedTypes: z.array(z.string()).optional(),
    contentFilterMinimumRating: z.number().optional(),
    contentFilterMinimumReviews: z.number().int().optional(),
    qosMaxConcurrentRequests: z.number().int().optional(),
    qosMaxRetries: z.number().int().optional(),
    qosRequestTimeout: z.string().optional(),
    qosEnableJavascript: z.boolean().optional(),
    respectRobotsTxt: z.boolean().optional(),
    acceptTermsOfService: z.boolean().optional(),
    userAgent: z.string().optional(),
    searchTerms: z.array(z.string()).optional(),
    scheduledEntryId: z.string().optional(),
  });

/** @internal */
export type PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsWorkflows$Outbound =
  {
    id?: string | undefined;
    name?: string | undefined;
    cronExpression?: string | undefined;
    nextRunTime?: string | undefined;
    lastRunTime?: string | undefined;
    status: string;
    retryCount?: number | undefined;
    maxRetries?: number | undefined;
    alertEmails?: string | undefined;
    createdAt?: string | undefined;
    updatedAt?: string | undefined;
    deletedAt?: string | undefined;
    jobs?:
      | Array<
        PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsJobs$Outbound
      >
      | undefined;
    geoFencingRadius?: number | undefined;
    geoFencingLat?: number | undefined;
    geoFencingLon?: number | undefined;
    geoFencingZoomMin?: number | undefined;
    geoFencingZoomMax?: number | undefined;
    includeReviews?: boolean | undefined;
    includePhotos?: boolean | undefined;
    includeBusinessHours?: boolean | undefined;
    maxReviewsPerBusiness?: number | undefined;
    outputFormat: string;
    outputDestination?: string | undefined;
    dataRetention?: string | undefined;
    anonymizePii?: boolean | undefined;
    notificationSlackChannel?: string | undefined;
    notificationEmailGroup?: string | undefined;
    notificationNotifyOnStart?: boolean | undefined;
    notificationNotifyOnComplete?: boolean | undefined;
    notificationNotifyOnFailure?: boolean | undefined;
    contentFilterAllowedCountries?: Array<string> | undefined;
    contentFilterExcludedTypes?: Array<string> | undefined;
    contentFilterMinimumRating?: number | undefined;
    contentFilterMinimumReviews?: number | undefined;
    qosMaxConcurrentRequests?: number | undefined;
    qosMaxRetries?: number | undefined;
    qosRequestTimeout?: string | undefined;
    qosEnableJavascript?: boolean | undefined;
    respectRobotsTxt?: boolean | undefined;
    acceptTermsOfService?: boolean | undefined;
    userAgent?: string | undefined;
    searchTerms?: Array<string> | undefined;
    scheduledEntryId?: string | undefined;
  };

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsWorkflows$outboundSchema:
  z.ZodType<
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsWorkflows$Outbound,
    z.ZodTypeDef,
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsWorkflows
  > = z.object({
    id: z.string().optional(),
    name: z.string().optional(),
    cronExpression: z.string().optional(),
    nextRunTime: z.date().transform(v => v.toISOString()).optional(),
    lastRunTime: z.date().transform(v => v.toISOString()).optional(),
    status:
      PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsStatus$outboundSchema
        .default("WORKFLOW_STATUS_UNSPECIFIED"),
    retryCount: z.number().int().optional(),
    maxRetries: z.number().int().optional(),
    alertEmails: z.string().optional(),
    createdAt: z.date().transform(v => v.toISOString()).optional(),
    updatedAt: z.date().transform(v => v.toISOString()).optional(),
    deletedAt: z.date().transform(v => v.toISOString()).optional(),
    jobs: z.array(
      z.lazy(() =>
        PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsJobs$outboundSchema
      ),
    ).optional(),
    geoFencingRadius: z.number().optional(),
    geoFencingLat: z.number().optional(),
    geoFencingLon: z.number().optional(),
    geoFencingZoomMin: z.number().int().optional(),
    geoFencingZoomMax: z.number().int().optional(),
    includeReviews: z.boolean().optional(),
    includePhotos: z.boolean().optional(),
    includeBusinessHours: z.boolean().optional(),
    maxReviewsPerBusiness: z.number().int().optional(),
    outputFormat:
      PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsOutputFormat$outboundSchema
        .default("OUTPUT_FORMAT_UNSPECIFIED"),
    outputDestination: z.string().optional(),
    dataRetention: z.string().optional(),
    anonymizePii: z.boolean().optional(),
    notificationSlackChannel: z.string().optional(),
    notificationEmailGroup: z.string().optional(),
    notificationNotifyOnStart: z.boolean().optional(),
    notificationNotifyOnComplete: z.boolean().optional(),
    notificationNotifyOnFailure: z.boolean().optional(),
    contentFilterAllowedCountries: z.array(z.string()).optional(),
    contentFilterExcludedTypes: z.array(z.string()).optional(),
    contentFilterMinimumRating: z.number().optional(),
    contentFilterMinimumReviews: z.number().int().optional(),
    qosMaxConcurrentRequests: z.number().int().optional(),
    qosMaxRetries: z.number().int().optional(),
    qosRequestTimeout: z.string().optional(),
    qosEnableJavascript: z.boolean().optional(),
    respectRobotsTxt: z.boolean().optional(),
    acceptTermsOfService: z.boolean().optional(),
    userAgent: z.string().optional(),
    searchTerms: z.array(z.string()).optional(),
    scheduledEntryId: z.string().optional(),
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsWorkflows$ {
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsWorkflows$inboundSchema` instead. */
  export const inboundSchema =
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsWorkflows$inboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsWorkflows$outboundSchema` instead. */
  export const outboundSchema =
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsWorkflows$outboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsWorkflows$Outbound` instead. */
  export type Outbound =
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsWorkflows$Outbound;
}

export function postApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsWorkflowsToJSON(
  postApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsWorkflows:
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsWorkflows,
): string {
  return JSON.stringify(
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsWorkflows$outboundSchema
      .parse(
        postApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsWorkflows,
      ),
  );
}

export function postApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsWorkflowsFromJSON(
  jsonString: string,
): SafeParseResult<
  PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsWorkflows,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsWorkflows$inboundSchema
        .parse(JSON.parse(x)),
    `Failed to parse 'PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsWorkflows' from JSON`,
  );
}

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsRequestStatus$inboundSchema:
  z.ZodNativeEnum<
    typeof PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsRequestStatus
  > = z.nativeEnum(
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsRequestStatus,
  );

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsRequestStatus$outboundSchema:
  z.ZodNativeEnum<
    typeof PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsRequestStatus
  > =
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsRequestStatus$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsRequestStatus$ {
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsRequestStatus$inboundSchema` instead. */
  export const inboundSchema =
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsRequestStatus$inboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsRequestStatus$outboundSchema` instead. */
  export const outboundSchema =
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsRequestStatus$outboundSchema;
}

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsLang$inboundSchema:
  z.ZodNativeEnum<
    typeof PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsLang
  > = z.nativeEnum(
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsLang,
  );

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsLang$outboundSchema:
  z.ZodNativeEnum<
    typeof PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsLang
  > =
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsLang$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsLang$ {
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsLang$inboundSchema` instead. */
  export const inboundSchema =
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsLang$inboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsLang$outboundSchema` instead. */
  export const outboundSchema =
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsLang$outboundSchema;
}

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsRequestDay$inboundSchema:
  z.ZodNativeEnum<
    typeof PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsRequestDay
  > = z.nativeEnum(
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsRequestDay,
  );

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsRequestDay$outboundSchema:
  z.ZodNativeEnum<
    typeof PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsRequestDay
  > =
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsRequestDay$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsRequestDay$ {
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsRequestDay$inboundSchema` instead. */
  export const inboundSchema =
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsRequestDay$inboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsRequestDay$outboundSchema` instead. */
  export const outboundSchema =
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsRequestDay$outboundSchema;
}

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsRegularHours$inboundSchema:
  z.ZodType<
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsRegularHours,
    z.ZodTypeDef,
    unknown
  > = z.object({
    id: z.string().optional(),
    day:
      PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsRequestDay$inboundSchema
        .default("DAY_OF_WEEK_UNSPECIFIED"),
    openTime: z.string().optional(),
    closeTime: z.string().optional(),
    closed: z.boolean().optional(),
    createdAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    updatedAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    deletedAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
  });

/** @internal */
export type PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsRegularHours$Outbound =
  {
    id?: string | undefined;
    day: string;
    openTime?: string | undefined;
    closeTime?: string | undefined;
    closed?: boolean | undefined;
    createdAt?: string | undefined;
    updatedAt?: string | undefined;
    deletedAt?: string | undefined;
  };

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsRegularHours$outboundSchema:
  z.ZodType<
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsRegularHours$Outbound,
    z.ZodTypeDef,
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsRegularHours
  > = z.object({
    id: z.string().optional(),
    day:
      PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsRequestDay$outboundSchema
        .default("DAY_OF_WEEK_UNSPECIFIED"),
    openTime: z.string().optional(),
    closeTime: z.string().optional(),
    closed: z.boolean().optional(),
    createdAt: z.date().transform(v => v.toISOString()).optional(),
    updatedAt: z.date().transform(v => v.toISOString()).optional(),
    deletedAt: z.date().transform(v => v.toISOString()).optional(),
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsRegularHours$ {
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsRegularHours$inboundSchema` instead. */
  export const inboundSchema =
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsRegularHours$inboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsRegularHours$outboundSchema` instead. */
  export const outboundSchema =
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsRegularHours$outboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsRegularHours$Outbound` instead. */
  export type Outbound =
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsRegularHours$Outbound;
}

export function postApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsRegularHoursToJSON(
  postApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsRegularHours:
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsRegularHours,
): string {
  return JSON.stringify(
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsRegularHours$outboundSchema
      .parse(
        postApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsRegularHours,
      ),
  );
}

export function postApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsRegularHoursFromJSON(
  jsonString: string,
): SafeParseResult<
  PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsRegularHours,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsRegularHours$inboundSchema
        .parse(JSON.parse(x)),
    `Failed to parse 'PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsRegularHours' from JSON`,
  );
}

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsRequestRequestBodyDay$inboundSchema:
  z.ZodNativeEnum<
    typeof PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsRequestRequestBodyDay
  > = z.nativeEnum(
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsRequestRequestBodyDay,
  );

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsRequestRequestBodyDay$outboundSchema:
  z.ZodNativeEnum<
    typeof PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsRequestRequestBodyDay
  > =
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsRequestRequestBodyDay$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsRequestRequestBodyDay$ {
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsRequestRequestBodyDay$inboundSchema` instead. */
  export const inboundSchema =
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsRequestRequestBodyDay$inboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsRequestRequestBodyDay$outboundSchema` instead. */
  export const outboundSchema =
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsRequestRequestBodyDay$outboundSchema;
}

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsSpecialHours$inboundSchema:
  z.ZodType<
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsSpecialHours,
    z.ZodTypeDef,
    unknown
  > = z.object({
    id: z.string().optional(),
    day:
      PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsRequestRequestBodyDay$inboundSchema
        .default("DAY_OF_WEEK_UNSPECIFIED"),
    openTime: z.string().optional(),
    closeTime: z.string().optional(),
    closed: z.boolean().optional(),
    createdAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    updatedAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    deletedAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
  });

/** @internal */
export type PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsSpecialHours$Outbound =
  {
    id?: string | undefined;
    day: string;
    openTime?: string | undefined;
    closeTime?: string | undefined;
    closed?: boolean | undefined;
    createdAt?: string | undefined;
    updatedAt?: string | undefined;
    deletedAt?: string | undefined;
  };

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsSpecialHours$outboundSchema:
  z.ZodType<
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsSpecialHours$Outbound,
    z.ZodTypeDef,
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsSpecialHours
  > = z.object({
    id: z.string().optional(),
    day:
      PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsRequestRequestBodyDay$outboundSchema
        .default("DAY_OF_WEEK_UNSPECIFIED"),
    openTime: z.string().optional(),
    closeTime: z.string().optional(),
    closed: z.boolean().optional(),
    createdAt: z.date().transform(v => v.toISOString()).optional(),
    updatedAt: z.date().transform(v => v.toISOString()).optional(),
    deletedAt: z.date().transform(v => v.toISOString()).optional(),
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsSpecialHours$ {
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsSpecialHours$inboundSchema` instead. */
  export const inboundSchema =
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsSpecialHours$inboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsSpecialHours$outboundSchema` instead. */
  export const outboundSchema =
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsSpecialHours$outboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsSpecialHours$Outbound` instead. */
  export type Outbound =
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsSpecialHours$Outbound;
}

export function postApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsSpecialHoursToJSON(
  postApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsSpecialHours:
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsSpecialHours,
): string {
  return JSON.stringify(
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsSpecialHours$outboundSchema
      .parse(
        postApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsSpecialHours,
      ),
  );
}

export function postApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsSpecialHoursFromJSON(
  jsonString: string,
): SafeParseResult<
  PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsSpecialHours,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsSpecialHours$inboundSchema
        .parse(JSON.parse(x)),
    `Failed to parse 'PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsSpecialHours' from JSON`,
  );
}

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsReviews$inboundSchema:
  z.ZodType<
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsReviews,
    z.ZodTypeDef,
    unknown
  > = z.object({
    id: z.string().optional(),
    author: z.string().optional(),
    rating: z.number().optional(),
    text: z.string().optional(),
    time: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    language: z.string().optional(),
    profilePhotoUrl: z.string().optional(),
    reviewCount: z.number().int().optional(),
    createdAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    updatedAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    deletedAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
  });

/** @internal */
export type PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsReviews$Outbound =
  {
    id?: string | undefined;
    author?: string | undefined;
    rating?: number | undefined;
    text?: string | undefined;
    time?: string | undefined;
    language?: string | undefined;
    profilePhotoUrl?: string | undefined;
    reviewCount?: number | undefined;
    createdAt?: string | undefined;
    updatedAt?: string | undefined;
    deletedAt?: string | undefined;
  };

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsReviews$outboundSchema:
  z.ZodType<
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsReviews$Outbound,
    z.ZodTypeDef,
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsReviews
  > = z.object({
    id: z.string().optional(),
    author: z.string().optional(),
    rating: z.number().optional(),
    text: z.string().optional(),
    time: z.date().transform(v => v.toISOString()).optional(),
    language: z.string().optional(),
    profilePhotoUrl: z.string().optional(),
    reviewCount: z.number().int().optional(),
    createdAt: z.date().transform(v => v.toISOString()).optional(),
    updatedAt: z.date().transform(v => v.toISOString()).optional(),
    deletedAt: z.date().transform(v => v.toISOString()).optional(),
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsReviews$ {
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsReviews$inboundSchema` instead. */
  export const inboundSchema =
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsReviews$inboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsReviews$outboundSchema` instead. */
  export const outboundSchema =
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsReviews$outboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsReviews$Outbound` instead. */
  export type Outbound =
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsReviews$Outbound;
}

export function postApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsReviewsToJSON(
  postApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsReviews:
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsReviews,
): string {
  return JSON.stringify(
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsReviews$outboundSchema
      .parse(
        postApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsReviews,
      ),
  );
}

export function postApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsReviewsFromJSON(
  jsonString: string,
): SafeParseResult<
  PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsReviews,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsReviews$inboundSchema
        .parse(JSON.parse(x)),
    `Failed to parse 'PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsReviews' from JSON`,
  );
}

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsRevenueRange$inboundSchema:
  z.ZodNativeEnum<
    typeof PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsRevenueRange
  > = z.nativeEnum(
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsRevenueRange,
  );

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsRevenueRange$outboundSchema:
  z.ZodNativeEnum<
    typeof PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsRevenueRange
  > =
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsRevenueRange$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsRevenueRange$ {
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsRevenueRange$inboundSchema` instead. */
  export const inboundSchema =
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsRevenueRange$inboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsRevenueRange$outboundSchema` instead. */
  export const outboundSchema =
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsRevenueRange$outboundSchema;
}

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsEmployeeBenefits$inboundSchema:
  z.ZodNativeEnum<
    typeof PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsEmployeeBenefits
  > = z.nativeEnum(
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsEmployeeBenefits,
  );

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsEmployeeBenefits$outboundSchema:
  z.ZodNativeEnum<
    typeof PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsEmployeeBenefits
  > =
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsEmployeeBenefits$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsEmployeeBenefits$ {
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsEmployeeBenefits$inboundSchema` instead. */
  export const inboundSchema =
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsEmployeeBenefits$inboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsEmployeeBenefits$outboundSchema` instead. */
  export const outboundSchema =
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsEmployeeBenefits$outboundSchema;
}

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsLeads$inboundSchema:
  z.ZodType<
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsLeads,
    z.ZodTypeDef,
    unknown
  > = z.object({
    id: z.string().optional(),
    name: z.string().optional(),
    website: z.string().optional(),
    phone: z.string().optional(),
    address: z.string().optional(),
    city: z.string().optional(),
    state: z.string().optional(),
    country: z.string().optional(),
    latitude: z.number().optional(),
    longitude: z.number().optional(),
    googleRating: z.number().optional(),
    reviewCount: z.number().int().optional(),
    industry: z.string().optional(),
    employeeCount: z.number().int().optional(),
    estimatedRevenue: z.string().optional(),
    createdAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    updatedAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    deletedAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    placeId: z.string().optional(),
    googleMapsUrl: z.string().optional(),
    businessStatus: z.string().optional(),
    regularHours: z.array(
      z.lazy(() =>
        PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsRegularHours$inboundSchema
      ),
    ).optional(),
    specialHours: z.array(
      z.lazy(() =>
        PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsSpecialHours$inboundSchema
      ),
    ).optional(),
    photoReferences: z.array(z.string()).optional(),
    mainPhotoUrl: z.string().optional(),
    reviews: z.array(
      z.lazy(() =>
        PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsReviews$inboundSchema
      ),
    ).optional(),
    types: z.array(z.string()).optional(),
    amenities: z.array(z.string()).optional(),
    servesVegetarianFood: z.boolean().optional(),
    outdoorSeating: z.boolean().optional(),
    paymentMethods: z.array(z.string()).optional(),
    wheelchairAccessible: z.boolean().optional(),
    parkingAvailable: z.boolean().optional(),
    socialMedia: z.record(z.string()).optional(),
    ratingCategory: z.string().optional(),
    rating: z.number().optional(),
    count: z.number().int().optional(),
    lastUpdated: z.string().datetime({ offset: true }).transform(v =>
      new Date(v)
    ).optional(),
    dataSourceVersion: z.string().optional(),
    scrapingSessionId: z.string().optional(),
    alternatePhones: z.array(z.string()).optional(),
    contactPersonName: z.string().optional(),
    contactPersonTitle: z.string().optional(),
    contactEmail: z.string().optional(),
    foundedYear: z.number().int().optional(),
    businessType: z.string().optional(),
    certifications: z.array(z.string()).optional(),
    licenseNumber: z.string().optional(),
    revenueRange:
      PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsRevenueRange$inboundSchema
        .default("REVENUE_RANGE_UNSPECIFIED"),
    fundingStage: z.string().optional(),
    isPublicCompany: z.boolean().optional(),
    websiteLoadSpeed: z.number().optional(),
    hasSslCertificate: z.boolean().optional(),
    cmsUsed: z.string().optional(),
    ecommercePlatforms: z.array(z.string()).optional(),
    timezone: z.string().optional(),
    neighborhood: z.string().optional(),
    nearbyLandmarks: z.array(z.string()).optional(),
    transportationAccess: z.string().optional(),
    employeeBenefits: z.array(
      PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsEmployeeBenefits$inboundSchema,
    ).optional(),
    parentCompany: z.string().optional(),
    subsidiaries: z.array(z.string()).optional(),
    isFranchise: z.boolean().optional(),
    seoKeywords: z.array(z.string()).optional(),
    usesGoogleAds: z.boolean().optional(),
    googleMyBusinessCategory: z.string().optional(),
    naicsCode: z.string().optional(),
    sicCode: z.string().optional(),
    unspscCode: z.string().optional(),
    isGreenCertified: z.boolean().optional(),
    energySources: z.array(z.string()).optional(),
    sustainabilityRating: z.string().optional(),
    recentAnnouncements: z.array(z.string()).optional(),
    lastProductLaunch: z.string().datetime({ offset: true }).transform(v =>
      new Date(v)
    ).optional(),
    hasLitigationHistory: z.boolean().optional(),
    exportControlStatus: z.string().optional(),
  });

/** @internal */
export type PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsLeads$Outbound =
  {
    id?: string | undefined;
    name?: string | undefined;
    website?: string | undefined;
    phone?: string | undefined;
    address?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    country?: string | undefined;
    latitude?: number | undefined;
    longitude?: number | undefined;
    googleRating?: number | undefined;
    reviewCount?: number | undefined;
    industry?: string | undefined;
    employeeCount?: number | undefined;
    estimatedRevenue?: string | undefined;
    createdAt?: string | undefined;
    updatedAt?: string | undefined;
    deletedAt?: string | undefined;
    placeId?: string | undefined;
    googleMapsUrl?: string | undefined;
    businessStatus?: string | undefined;
    regularHours?:
      | Array<
        PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsRegularHours$Outbound
      >
      | undefined;
    specialHours?:
      | Array<
        PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsSpecialHours$Outbound
      >
      | undefined;
    photoReferences?: Array<string> | undefined;
    mainPhotoUrl?: string | undefined;
    reviews?:
      | Array<
        PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsReviews$Outbound
      >
      | undefined;
    types?: Array<string> | undefined;
    amenities?: Array<string> | undefined;
    servesVegetarianFood?: boolean | undefined;
    outdoorSeating?: boolean | undefined;
    paymentMethods?: Array<string> | undefined;
    wheelchairAccessible?: boolean | undefined;
    parkingAvailable?: boolean | undefined;
    socialMedia?: { [k: string]: string } | undefined;
    ratingCategory?: string | undefined;
    rating?: number | undefined;
    count?: number | undefined;
    lastUpdated?: string | undefined;
    dataSourceVersion?: string | undefined;
    scrapingSessionId?: string | undefined;
    alternatePhones?: Array<string> | undefined;
    contactPersonName?: string | undefined;
    contactPersonTitle?: string | undefined;
    contactEmail?: string | undefined;
    foundedYear?: number | undefined;
    businessType?: string | undefined;
    certifications?: Array<string> | undefined;
    licenseNumber?: string | undefined;
    revenueRange: string;
    fundingStage?: string | undefined;
    isPublicCompany?: boolean | undefined;
    websiteLoadSpeed?: number | undefined;
    hasSslCertificate?: boolean | undefined;
    cmsUsed?: string | undefined;
    ecommercePlatforms?: Array<string> | undefined;
    timezone?: string | undefined;
    neighborhood?: string | undefined;
    nearbyLandmarks?: Array<string> | undefined;
    transportationAccess?: string | undefined;
    employeeBenefits?: Array<string> | undefined;
    parentCompany?: string | undefined;
    subsidiaries?: Array<string> | undefined;
    isFranchise?: boolean | undefined;
    seoKeywords?: Array<string> | undefined;
    usesGoogleAds?: boolean | undefined;
    googleMyBusinessCategory?: string | undefined;
    naicsCode?: string | undefined;
    sicCode?: string | undefined;
    unspscCode?: string | undefined;
    isGreenCertified?: boolean | undefined;
    energySources?: Array<string> | undefined;
    sustainabilityRating?: string | undefined;
    recentAnnouncements?: Array<string> | undefined;
    lastProductLaunch?: string | undefined;
    hasLitigationHistory?: boolean | undefined;
    exportControlStatus?: string | undefined;
  };

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsLeads$outboundSchema:
  z.ZodType<
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsLeads$Outbound,
    z.ZodTypeDef,
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsLeads
  > = z.object({
    id: z.string().optional(),
    name: z.string().optional(),
    website: z.string().optional(),
    phone: z.string().optional(),
    address: z.string().optional(),
    city: z.string().optional(),
    state: z.string().optional(),
    country: z.string().optional(),
    latitude: z.number().optional(),
    longitude: z.number().optional(),
    googleRating: z.number().optional(),
    reviewCount: z.number().int().optional(),
    industry: z.string().optional(),
    employeeCount: z.number().int().optional(),
    estimatedRevenue: z.string().optional(),
    createdAt: z.date().transform(v => v.toISOString()).optional(),
    updatedAt: z.date().transform(v => v.toISOString()).optional(),
    deletedAt: z.date().transform(v => v.toISOString()).optional(),
    placeId: z.string().optional(),
    googleMapsUrl: z.string().optional(),
    businessStatus: z.string().optional(),
    regularHours: z.array(
      z.lazy(() =>
        PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsRegularHours$outboundSchema
      ),
    ).optional(),
    specialHours: z.array(
      z.lazy(() =>
        PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsSpecialHours$outboundSchema
      ),
    ).optional(),
    photoReferences: z.array(z.string()).optional(),
    mainPhotoUrl: z.string().optional(),
    reviews: z.array(
      z.lazy(() =>
        PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsReviews$outboundSchema
      ),
    ).optional(),
    types: z.array(z.string()).optional(),
    amenities: z.array(z.string()).optional(),
    servesVegetarianFood: z.boolean().optional(),
    outdoorSeating: z.boolean().optional(),
    paymentMethods: z.array(z.string()).optional(),
    wheelchairAccessible: z.boolean().optional(),
    parkingAvailable: z.boolean().optional(),
    socialMedia: z.record(z.string()).optional(),
    ratingCategory: z.string().optional(),
    rating: z.number().optional(),
    count: z.number().int().optional(),
    lastUpdated: z.date().transform(v => v.toISOString()).optional(),
    dataSourceVersion: z.string().optional(),
    scrapingSessionId: z.string().optional(),
    alternatePhones: z.array(z.string()).optional(),
    contactPersonName: z.string().optional(),
    contactPersonTitle: z.string().optional(),
    contactEmail: z.string().optional(),
    foundedYear: z.number().int().optional(),
    businessType: z.string().optional(),
    certifications: z.array(z.string()).optional(),
    licenseNumber: z.string().optional(),
    revenueRange:
      PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsRevenueRange$outboundSchema
        .default("REVENUE_RANGE_UNSPECIFIED"),
    fundingStage: z.string().optional(),
    isPublicCompany: z.boolean().optional(),
    websiteLoadSpeed: z.number().optional(),
    hasSslCertificate: z.boolean().optional(),
    cmsUsed: z.string().optional(),
    ecommercePlatforms: z.array(z.string()).optional(),
    timezone: z.string().optional(),
    neighborhood: z.string().optional(),
    nearbyLandmarks: z.array(z.string()).optional(),
    transportationAccess: z.string().optional(),
    employeeBenefits: z.array(
      PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsEmployeeBenefits$outboundSchema,
    ).optional(),
    parentCompany: z.string().optional(),
    subsidiaries: z.array(z.string()).optional(),
    isFranchise: z.boolean().optional(),
    seoKeywords: z.array(z.string()).optional(),
    usesGoogleAds: z.boolean().optional(),
    googleMyBusinessCategory: z.string().optional(),
    naicsCode: z.string().optional(),
    sicCode: z.string().optional(),
    unspscCode: z.string().optional(),
    isGreenCertified: z.boolean().optional(),
    energySources: z.array(z.string()).optional(),
    sustainabilityRating: z.string().optional(),
    recentAnnouncements: z.array(z.string()).optional(),
    lastProductLaunch: z.date().transform(v => v.toISOString()).optional(),
    hasLitigationHistory: z.boolean().optional(),
    exportControlStatus: z.string().optional(),
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsLeads$ {
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsLeads$inboundSchema` instead. */
  export const inboundSchema =
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsLeads$inboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsLeads$outboundSchema` instead. */
  export const outboundSchema =
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsLeads$outboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsLeads$Outbound` instead. */
  export type Outbound =
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsLeads$Outbound;
}

export function postApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsLeadsToJSON(
  postApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsLeads:
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsLeads,
): string {
  return JSON.stringify(
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsLeads$outboundSchema
      .parse(
        postApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsLeads,
      ),
  );
}

export function postApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsLeadsFromJSON(
  jsonString: string,
): SafeParseResult<
  PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsLeads,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsLeads$inboundSchema
        .parse(JSON.parse(x)),
    `Failed to parse 'PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsLeads' from JSON`,
  );
}

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsScrapingJobs$inboundSchema:
  z.ZodType<
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsScrapingJobs,
    z.ZodTypeDef,
    unknown
  > = z.object({
    id: z.string().optional(),
    priority: z.number().int().optional(),
    payloadType: z.string().optional(),
    payload: z.string().optional(),
    createdAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    status:
      PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsRequestStatus$inboundSchema
        .default("BACKGROUND_JOB_STATUS_UNSPECIFIED"),
    name: z.string().optional(),
    keywords: z.array(z.string()).optional(),
    lang:
      PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsLang$inboundSchema
        .default("LANGUAGE_UNSPECIFIED"),
    zoom: z.number().int().optional(),
    lat: z.string().optional(),
    lon: z.string().optional(),
    fastMode: z.boolean().optional(),
    radius: z.number().int().optional(),
    depth: z.number().int().optional(),
    email: z.boolean().optional(),
    maxTime: z.number().int().optional(),
    proxies: z.array(z.string()).optional(),
    updatedAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    deletedAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    leads: z.array(
      z.lazy(() =>
        PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsLeads$inboundSchema
      ),
    ).optional(),
    url: z.string().optional(),
  });

/** @internal */
export type PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsScrapingJobs$Outbound =
  {
    id?: string | undefined;
    priority?: number | undefined;
    payloadType?: string | undefined;
    payload?: string | undefined;
    createdAt?: string | undefined;
    status: string;
    name?: string | undefined;
    keywords?: Array<string> | undefined;
    lang: string;
    zoom?: number | undefined;
    lat?: string | undefined;
    lon?: string | undefined;
    fastMode?: boolean | undefined;
    radius?: number | undefined;
    depth?: number | undefined;
    email?: boolean | undefined;
    maxTime?: number | undefined;
    proxies?: Array<string> | undefined;
    updatedAt?: string | undefined;
    deletedAt?: string | undefined;
    leads?:
      | Array<
        PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsLeads$Outbound
      >
      | undefined;
    url?: string | undefined;
  };

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsScrapingJobs$outboundSchema:
  z.ZodType<
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsScrapingJobs$Outbound,
    z.ZodTypeDef,
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsScrapingJobs
  > = z.object({
    id: z.string().optional(),
    priority: z.number().int().optional(),
    payloadType: z.string().optional(),
    payload: z.string().optional(),
    createdAt: z.date().transform(v => v.toISOString()).optional(),
    status:
      PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsRequestStatus$outboundSchema
        .default("BACKGROUND_JOB_STATUS_UNSPECIFIED"),
    name: z.string().optional(),
    keywords: z.array(z.string()).optional(),
    lang:
      PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsLang$outboundSchema
        .default("LANGUAGE_UNSPECIFIED"),
    zoom: z.number().int().optional(),
    lat: z.string().optional(),
    lon: z.string().optional(),
    fastMode: z.boolean().optional(),
    radius: z.number().int().optional(),
    depth: z.number().int().optional(),
    email: z.boolean().optional(),
    maxTime: z.number().int().optional(),
    proxies: z.array(z.string()).optional(),
    updatedAt: z.date().transform(v => v.toISOString()).optional(),
    deletedAt: z.date().transform(v => v.toISOString()).optional(),
    leads: z.array(
      z.lazy(() =>
        PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsLeads$outboundSchema
      ),
    ).optional(),
    url: z.string().optional(),
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsScrapingJobs$ {
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsScrapingJobs$inboundSchema` instead. */
  export const inboundSchema =
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsScrapingJobs$inboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsScrapingJobs$outboundSchema` instead. */
  export const outboundSchema =
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsScrapingJobs$outboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsScrapingJobs$Outbound` instead. */
  export type Outbound =
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsScrapingJobs$Outbound;
}

export function postApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsScrapingJobsToJSON(
  postApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsScrapingJobs:
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsScrapingJobs,
): string {
  return JSON.stringify(
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsScrapingJobs$outboundSchema
      .parse(
        postApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsScrapingJobs,
      ),
  );
}

export function postApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsScrapingJobsFromJSON(
  jsonString: string,
): SafeParseResult<
  PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsScrapingJobs,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsScrapingJobs$inboundSchema
        .parse(JSON.parse(x)),
    `Failed to parse 'PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsScrapingJobs' from JSON`,
  );
}

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsRequestRequestBodyStatus$inboundSchema:
  z.ZodNativeEnum<
    typeof PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsRequestRequestBodyStatus
  > = z.nativeEnum(
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsRequestRequestBodyStatus,
  );

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsRequestRequestBodyStatus$outboundSchema:
  z.ZodNativeEnum<
    typeof PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsRequestRequestBodyStatus
  > =
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsRequestRequestBodyStatus$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsRequestRequestBodyStatus$ {
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsRequestRequestBodyStatus$inboundSchema` instead. */
  export const inboundSchema =
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsRequestRequestBodyStatus$inboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsRequestRequestBodyStatus$outboundSchema` instead. */
  export const outboundSchema =
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsRequestRequestBodyStatus$outboundSchema;
}

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsApiKeys$inboundSchema:
  z.ZodType<
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsApiKeys,
    z.ZodTypeDef,
    unknown
  > = z.object({
    id: z.string().optional(),
    name: z.string().optional(),
    keyHash: z.string().optional(),
    keyPrefix: z.string().optional(),
    scopes: z.array(z.string()).optional(),
    allowedIps: z.array(z.string()).optional(),
    allowedDomains: z.array(z.string()).optional(),
    allowedEnvironments: z.array(z.string()).optional(),
    isTestKey: z.boolean().optional(),
    requestsPerSecond: z.number().int().optional(),
    requestsPerDay: z.number().int().optional(),
    concurrentRequests: z.number().int().optional(),
    monthlyRequestQuota: z.string().optional(),
    costPerRequest: z.number().optional(),
    billingTier: z.string().optional(),
    totalRequests: z.string().optional(),
    totalErrors: z.string().optional(),
    lastUsedAt: z.string().datetime({ offset: true }).transform(v =>
      new Date(v)
    ).optional(),
    averageResponseTime: z.number().optional(),
    endpointUsageJson: z.string().optional(),
    errorRatesJson: z.string().optional(),
    recentErrors: z.string().optional(),
    successfulRequestsCount: z.number().int().optional(),
    successRate: z.number().optional(),
    status:
      PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsRequestRequestBodyStatus$inboundSchema
        .default("STATUS_UNSPECIFIED"),
    createdAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    updatedAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    expiresAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    deletedAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    lastRotatedAt: z.string().datetime({ offset: true }).transform(v =>
      new Date(v)
    ).optional(),
    lastSecurityReviewAt: z.string().datetime({ offset: true }).transform(v =>
      new Date(v)
    ).optional(),
    requiresClientSecret: z.boolean().optional(),
    clientSecretHash: z.string().optional(),
    enforceHttps: z.boolean().optional(),
    enforceSigning: z.boolean().optional(),
    allowedSignatureAlgorithms: z.array(z.string()).optional(),
    enforceMutualTls: z.boolean().optional(),
    clientCertificateHash: z.string().optional(),
    requireRequestSigning: z.boolean().optional(),
    description: z.string().optional(),
    metadataJson: z.string().optional(),
    tags: z.array(z.string()).optional(),
    apiVersion: z.string().optional(),
    supportedFeatures: z.array(z.string()).optional(),
    documentationUrl: z.string().optional(),
    supportContact: z.string().optional(),
    logAllRequests: z.boolean().optional(),
    lastRotationReason: z.string().optional(),
    lastRotationDate: z.string().datetime({ offset: true }).transform(v =>
      new Date(v)
    ).optional(),
    rotationFrequencyDays: z.number().int().optional(),
    complianceStandards: z.array(z.string()).optional(),
    requiresAuditLogging: z.boolean().optional(),
    dataResidency: z.string().optional(),
    approvedIntegrations: z.array(z.string()).optional(),
    alertEmails: z.array(z.string()).optional(),
    webhookUrl: z.string().optional(),
    alertOnQuotaThreshold: z.boolean().optional(),
    quotaAlertThreshold: z.number().optional(),
    alertOnErrorSpike: z.boolean().optional(),
    errorAlertThreshold: z.number().optional(),
    monitoringIntegrations: z.array(z.string()).optional(),
    encrypted: z.boolean().optional(),
    dataClassification: z.string().optional(),
    maxUses: z.number().int().optional(),
    rateLimit: z.number().int().optional(),
  });

/** @internal */
export type PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsApiKeys$Outbound =
  {
    id?: string | undefined;
    name?: string | undefined;
    keyHash?: string | undefined;
    keyPrefix?: string | undefined;
    scopes?: Array<string> | undefined;
    allowedIps?: Array<string> | undefined;
    allowedDomains?: Array<string> | undefined;
    allowedEnvironments?: Array<string> | undefined;
    isTestKey?: boolean | undefined;
    requestsPerSecond?: number | undefined;
    requestsPerDay?: number | undefined;
    concurrentRequests?: number | undefined;
    monthlyRequestQuota?: string | undefined;
    costPerRequest?: number | undefined;
    billingTier?: string | undefined;
    totalRequests?: string | undefined;
    totalErrors?: string | undefined;
    lastUsedAt?: string | undefined;
    averageResponseTime?: number | undefined;
    endpointUsageJson?: string | undefined;
    errorRatesJson?: string | undefined;
    recentErrors?: string | undefined;
    successfulRequestsCount?: number | undefined;
    successRate?: number | undefined;
    status: string;
    createdAt?: string | undefined;
    updatedAt?: string | undefined;
    expiresAt?: string | undefined;
    deletedAt?: string | undefined;
    lastRotatedAt?: string | undefined;
    lastSecurityReviewAt?: string | undefined;
    requiresClientSecret?: boolean | undefined;
    clientSecretHash?: string | undefined;
    enforceHttps?: boolean | undefined;
    enforceSigning?: boolean | undefined;
    allowedSignatureAlgorithms?: Array<string> | undefined;
    enforceMutualTls?: boolean | undefined;
    clientCertificateHash?: string | undefined;
    requireRequestSigning?: boolean | undefined;
    description?: string | undefined;
    metadataJson?: string | undefined;
    tags?: Array<string> | undefined;
    apiVersion?: string | undefined;
    supportedFeatures?: Array<string> | undefined;
    documentationUrl?: string | undefined;
    supportContact?: string | undefined;
    logAllRequests?: boolean | undefined;
    lastRotationReason?: string | undefined;
    lastRotationDate?: string | undefined;
    rotationFrequencyDays?: number | undefined;
    complianceStandards?: Array<string> | undefined;
    requiresAuditLogging?: boolean | undefined;
    dataResidency?: string | undefined;
    approvedIntegrations?: Array<string> | undefined;
    alertEmails?: Array<string> | undefined;
    webhookUrl?: string | undefined;
    alertOnQuotaThreshold?: boolean | undefined;
    quotaAlertThreshold?: number | undefined;
    alertOnErrorSpike?: boolean | undefined;
    errorAlertThreshold?: number | undefined;
    monitoringIntegrations?: Array<string> | undefined;
    encrypted?: boolean | undefined;
    dataClassification?: string | undefined;
    maxUses?: number | undefined;
    rateLimit?: number | undefined;
  };

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsApiKeys$outboundSchema:
  z.ZodType<
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsApiKeys$Outbound,
    z.ZodTypeDef,
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsApiKeys
  > = z.object({
    id: z.string().optional(),
    name: z.string().optional(),
    keyHash: z.string().optional(),
    keyPrefix: z.string().optional(),
    scopes: z.array(z.string()).optional(),
    allowedIps: z.array(z.string()).optional(),
    allowedDomains: z.array(z.string()).optional(),
    allowedEnvironments: z.array(z.string()).optional(),
    isTestKey: z.boolean().optional(),
    requestsPerSecond: z.number().int().optional(),
    requestsPerDay: z.number().int().optional(),
    concurrentRequests: z.number().int().optional(),
    monthlyRequestQuota: z.string().optional(),
    costPerRequest: z.number().optional(),
    billingTier: z.string().optional(),
    totalRequests: z.string().optional(),
    totalErrors: z.string().optional(),
    lastUsedAt: z.date().transform(v => v.toISOString()).optional(),
    averageResponseTime: z.number().optional(),
    endpointUsageJson: z.string().optional(),
    errorRatesJson: z.string().optional(),
    recentErrors: z.string().optional(),
    successfulRequestsCount: z.number().int().optional(),
    successRate: z.number().optional(),
    status:
      PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsRequestRequestBodyStatus$outboundSchema
        .default("STATUS_UNSPECIFIED"),
    createdAt: z.date().transform(v => v.toISOString()).optional(),
    updatedAt: z.date().transform(v => v.toISOString()).optional(),
    expiresAt: z.date().transform(v => v.toISOString()).optional(),
    deletedAt: z.date().transform(v => v.toISOString()).optional(),
    lastRotatedAt: z.date().transform(v => v.toISOString()).optional(),
    lastSecurityReviewAt: z.date().transform(v => v.toISOString()).optional(),
    requiresClientSecret: z.boolean().optional(),
    clientSecretHash: z.string().optional(),
    enforceHttps: z.boolean().optional(),
    enforceSigning: z.boolean().optional(),
    allowedSignatureAlgorithms: z.array(z.string()).optional(),
    enforceMutualTls: z.boolean().optional(),
    clientCertificateHash: z.string().optional(),
    requireRequestSigning: z.boolean().optional(),
    description: z.string().optional(),
    metadataJson: z.string().optional(),
    tags: z.array(z.string()).optional(),
    apiVersion: z.string().optional(),
    supportedFeatures: z.array(z.string()).optional(),
    documentationUrl: z.string().optional(),
    supportContact: z.string().optional(),
    logAllRequests: z.boolean().optional(),
    lastRotationReason: z.string().optional(),
    lastRotationDate: z.date().transform(v => v.toISOString()).optional(),
    rotationFrequencyDays: z.number().int().optional(),
    complianceStandards: z.array(z.string()).optional(),
    requiresAuditLogging: z.boolean().optional(),
    dataResidency: z.string().optional(),
    approvedIntegrations: z.array(z.string()).optional(),
    alertEmails: z.array(z.string()).optional(),
    webhookUrl: z.string().optional(),
    alertOnQuotaThreshold: z.boolean().optional(),
    quotaAlertThreshold: z.number().optional(),
    alertOnErrorSpike: z.boolean().optional(),
    errorAlertThreshold: z.number().optional(),
    monitoringIntegrations: z.array(z.string()).optional(),
    encrypted: z.boolean().optional(),
    dataClassification: z.string().optional(),
    maxUses: z.number().int().optional(),
    rateLimit: z.number().int().optional(),
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsApiKeys$ {
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsApiKeys$inboundSchema` instead. */
  export const inboundSchema =
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsApiKeys$inboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsApiKeys$outboundSchema` instead. */
  export const outboundSchema =
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsApiKeys$outboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsApiKeys$Outbound` instead. */
  export type Outbound =
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsApiKeys$Outbound;
}

export function postApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsApiKeysToJSON(
  postApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsApiKeys:
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsApiKeys,
): string {
  return JSON.stringify(
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsApiKeys$outboundSchema
      .parse(
        postApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsApiKeys,
      ),
  );
}

export function postApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsApiKeysFromJSON(
  jsonString: string,
): SafeParseResult<
  PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsApiKeys,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsApiKeys$inboundSchema
        .parse(JSON.parse(x)),
    `Failed to parse 'PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsApiKeys' from JSON`,
  );
}

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTriggerEvents$inboundSchema:
  z.ZodNativeEnum<
    typeof PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTriggerEvents
  > = z.nativeEnum(
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTriggerEvents,
  );

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTriggerEvents$outboundSchema:
  z.ZodNativeEnum<
    typeof PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTriggerEvents
  > =
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTriggerEvents$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTriggerEvents$ {
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTriggerEvents$inboundSchema` instead. */
  export const inboundSchema =
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTriggerEvents$inboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTriggerEvents$outboundSchema` instead. */
  export const outboundSchema =
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTriggerEvents$outboundSchema;
}

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsIncludedFields$inboundSchema:
  z.ZodNativeEnum<
    typeof PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsIncludedFields
  > = z.nativeEnum(
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsIncludedFields,
  );

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsIncludedFields$outboundSchema:
  z.ZodNativeEnum<
    typeof PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsIncludedFields
  > =
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsIncludedFields$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsIncludedFields$ {
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsIncludedFields$inboundSchema` instead. */
  export const inboundSchema =
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsIncludedFields$inboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsIncludedFields$outboundSchema` instead. */
  export const outboundSchema =
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsIncludedFields$outboundSchema;
}

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsPayloadFormat$inboundSchema:
  z.ZodNativeEnum<
    typeof PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsPayloadFormat
  > = z.nativeEnum(
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsPayloadFormat,
  );

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsPayloadFormat$outboundSchema:
  z.ZodNativeEnum<
    typeof PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsPayloadFormat
  > =
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsPayloadFormat$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsPayloadFormat$ {
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsPayloadFormat$inboundSchema` instead. */
  export const inboundSchema =
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsPayloadFormat$inboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsPayloadFormat$outboundSchema` instead. */
  export const outboundSchema =
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsPayloadFormat$outboundSchema;
}

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsMetadata$inboundSchema:
  z.ZodType<
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsMetadata,
    z.ZodTypeDef,
    unknown
  > = z.object({});

/** @internal */
export type PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsMetadata$Outbound =
  {};

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsMetadata$outboundSchema:
  z.ZodType<
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsMetadata$Outbound,
    z.ZodTypeDef,
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsMetadata
  > = z.object({});

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsMetadata$ {
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsMetadata$inboundSchema` instead. */
  export const inboundSchema =
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsMetadata$inboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsMetadata$outboundSchema` instead. */
  export const outboundSchema =
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsMetadata$outboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsMetadata$Outbound` instead. */
  export type Outbound =
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsMetadata$Outbound;
}

export function postApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsMetadataToJSON(
  postApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsMetadata:
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsMetadata,
): string {
  return JSON.stringify(
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsMetadata$outboundSchema
      .parse(
        postApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsMetadata,
      ),
  );
}

export function postApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsMetadataFromJSON(
  jsonString: string,
): SafeParseResult<
  PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsMetadata,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsMetadata$inboundSchema
        .parse(JSON.parse(x)),
    `Failed to parse 'PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsMetadata' from JSON`,
  );
}

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsWebhooks$inboundSchema:
  z.ZodType<
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsWebhooks,
    z.ZodTypeDef,
    unknown
  > = z.object({
    id: z.string().optional(),
    url: z.string().optional(),
    authType: z.string().optional(),
    authToken: z.string().optional(),
    customHeaders: z.record(z.string()).optional(),
    maxRetries: z.number().int().optional(),
    retryInterval: z.string().optional(),
    triggerEvents: z.array(
      PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTriggerEvents$inboundSchema,
    ).optional(),
    includedFields: z.array(
      PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsIncludedFields$inboundSchema,
    ).optional(),
    includeFullResults: z.boolean().optional(),
    payloadFormat:
      PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsPayloadFormat$inboundSchema
        .default("PAYLOAD_FORMAT_UNSPECIFIED"),
    verifySsl: z.boolean().optional(),
    signingSecret: z.string().optional(),
    rateLimit: z.number().int().optional(),
    rateLimitInterval: z.string().optional(),
    createdAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    updatedAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    lastTriggeredAt: z.string().datetime({ offset: true }).transform(v =>
      new Date(v)
    ).optional(),
    successfulCalls: z.number().int().optional(),
    failedCalls: z.number().int().optional(),
    metadata: z.lazy(() =>
      PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsMetadata$inboundSchema
    ).optional(),
    webhookName: z.string().optional(),
  });

/** @internal */
export type PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsWebhooks$Outbound =
  {
    id?: string | undefined;
    url?: string | undefined;
    authType?: string | undefined;
    authToken?: string | undefined;
    customHeaders?: { [k: string]: string } | undefined;
    maxRetries?: number | undefined;
    retryInterval?: string | undefined;
    triggerEvents?: Array<string> | undefined;
    includedFields?: Array<string> | undefined;
    includeFullResults?: boolean | undefined;
    payloadFormat: string;
    verifySsl?: boolean | undefined;
    signingSecret?: string | undefined;
    rateLimit?: number | undefined;
    rateLimitInterval?: string | undefined;
    createdAt?: string | undefined;
    updatedAt?: string | undefined;
    lastTriggeredAt?: string | undefined;
    successfulCalls?: number | undefined;
    failedCalls?: number | undefined;
    metadata?:
      | PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsMetadata$Outbound
      | undefined;
    webhookName?: string | undefined;
  };

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsWebhooks$outboundSchema:
  z.ZodType<
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsWebhooks$Outbound,
    z.ZodTypeDef,
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsWebhooks
  > = z.object({
    id: z.string().optional(),
    url: z.string().optional(),
    authType: z.string().optional(),
    authToken: z.string().optional(),
    customHeaders: z.record(z.string()).optional(),
    maxRetries: z.number().int().optional(),
    retryInterval: z.string().optional(),
    triggerEvents: z.array(
      PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTriggerEvents$outboundSchema,
    ).optional(),
    includedFields: z.array(
      PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsIncludedFields$outboundSchema,
    ).optional(),
    includeFullResults: z.boolean().optional(),
    payloadFormat:
      PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsPayloadFormat$outboundSchema
        .default("PAYLOAD_FORMAT_UNSPECIFIED"),
    verifySsl: z.boolean().optional(),
    signingSecret: z.string().optional(),
    rateLimit: z.number().int().optional(),
    rateLimitInterval: z.string().optional(),
    createdAt: z.date().transform(v => v.toISOString()).optional(),
    updatedAt: z.date().transform(v => v.toISOString()).optional(),
    lastTriggeredAt: z.date().transform(v => v.toISOString()).optional(),
    successfulCalls: z.number().int().optional(),
    failedCalls: z.number().int().optional(),
    metadata: z.lazy(() =>
      PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsMetadata$outboundSchema
    ).optional(),
    webhookName: z.string().optional(),
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsWebhooks$ {
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsWebhooks$inboundSchema` instead. */
  export const inboundSchema =
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsWebhooks$inboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsWebhooks$outboundSchema` instead. */
  export const outboundSchema =
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsWebhooks$outboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsWebhooks$Outbound` instead. */
  export type Outbound =
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsWebhooks$Outbound;
}

export function postApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsWebhooksToJSON(
  postApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsWebhooks:
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsWebhooks,
): string {
  return JSON.stringify(
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsWebhooks$outboundSchema
      .parse(
        postApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsWebhooks,
      ),
  );
}

export function postApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsWebhooksFromJSON(
  jsonString: string,
): SafeParseResult<
  PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsWebhooks,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsWebhooks$inboundSchema
        .parse(JSON.parse(x)),
    `Failed to parse 'PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsWebhooks' from JSON`,
  );
}

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsWorkspaceType$inboundSchema:
  z.ZodNativeEnum<
    typeof PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsWorkspaceType
  > = z.nativeEnum(
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsWorkspaceType,
  );

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsWorkspaceType$outboundSchema:
  z.ZodNativeEnum<
    typeof PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsWorkspaceType
  > =
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsWorkspaceType$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsWorkspaceType$ {
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsWorkspaceType$inboundSchema` instead. */
  export const inboundSchema =
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsWorkspaceType$inboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsWorkspaceType$outboundSchema` instead. */
  export const outboundSchema =
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsWorkspaceType$outboundSchema;
}

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsWorkspaces$inboundSchema:
  z.ZodType<
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsWorkspaces,
    z.ZodTypeDef,
    unknown
  > = z.object({
    id: z.string().optional(),
    name: z.string().optional(),
    industry: z.string().optional(),
    domain: z.string().optional(),
    gdprCompliant: z.boolean().optional(),
    hipaaCompliant: z.boolean().optional(),
    soc2Compliant: z.boolean().optional(),
    storageQuota: z.string().optional(),
    usedStorage: z.string().optional(),
    createdAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    updatedAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    deletedAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    workflows: z.array(
      z.lazy(() =>
        PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsWorkflows$inboundSchema
      ),
    ).optional(),
    jobsRunThisMonth: z.number().int().optional(),
    workspaceJobLimit: z.number().int().optional(),
    dailyJobQuota: z.number().int().optional(),
    activeScrapers: z.number().int().optional(),
    totalLeadsCollected: z.number().int().optional(),
    lastJobRun: z.string().datetime({ offset: true }).transform(v =>
      new Date(v)
    ).optional(),
    scrapingJobs: z.array(
      z.lazy(() =>
        PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsScrapingJobs$inboundSchema
      ),
    ).optional(),
    apiKeys: z.array(
      z.lazy(() =>
        PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsApiKeys$inboundSchema
      ),
    ).optional(),
    webhooks: z.array(
      z.lazy(() =>
        PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsWebhooks$inboundSchema
      ),
    ).optional(),
    workspaceType:
      PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsWorkspaceType$inboundSchema
        .default("WORKSPACE_TYPE_UNSPECIFIED"),
    description: z.string().optional(),
    metadata: z.record(z.string()).optional(),
    tags: z.array(z.string()).optional(),
    maxTeamMembers: z.number().int().optional(),
    currentTeamMembers: z.number().int().optional(),
    allowGuestAccess: z.boolean().optional(),
    allowedEmailDomains: z.array(z.string()).optional(),
    exportFormats: z.array(z.string()).optional(),
    exportSchedule: z.string().optional(),
    exportDestinations: z.array(z.string()).optional(),
    exportDestinationConfig: z.record(z.string()).optional(),
    compressExports: z.boolean().optional(),
    compressionFormat: z.string().optional(),
    salesforceEnabled: z.boolean().optional(),
    salesforceConfig: z.string().optional(),
    hubspotEnabled: z.boolean().optional(),
    hubspotConfig: z.string().optional(),
    zapierEnabled: z.boolean().optional(),
    zapierWebhook: z.string().optional(),
    activeIntegrations: z.array(z.string()).optional(),
    integrationSettings: z.record(z.string()).optional(),
  });

/** @internal */
export type PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsWorkspaces$Outbound =
  {
    id?: string | undefined;
    name?: string | undefined;
    industry?: string | undefined;
    domain?: string | undefined;
    gdprCompliant?: boolean | undefined;
    hipaaCompliant?: boolean | undefined;
    soc2Compliant?: boolean | undefined;
    storageQuota?: string | undefined;
    usedStorage?: string | undefined;
    createdAt?: string | undefined;
    updatedAt?: string | undefined;
    deletedAt?: string | undefined;
    workflows?:
      | Array<
        PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsWorkflows$Outbound
      >
      | undefined;
    jobsRunThisMonth?: number | undefined;
    workspaceJobLimit?: number | undefined;
    dailyJobQuota?: number | undefined;
    activeScrapers?: number | undefined;
    totalLeadsCollected?: number | undefined;
    lastJobRun?: string | undefined;
    scrapingJobs?:
      | Array<
        PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsScrapingJobs$Outbound
      >
      | undefined;
    apiKeys?:
      | Array<
        PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsApiKeys$Outbound
      >
      | undefined;
    webhooks?:
      | Array<
        PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsWebhooks$Outbound
      >
      | undefined;
    workspaceType: string;
    description?: string | undefined;
    metadata?: { [k: string]: string } | undefined;
    tags?: Array<string> | undefined;
    maxTeamMembers?: number | undefined;
    currentTeamMembers?: number | undefined;
    allowGuestAccess?: boolean | undefined;
    allowedEmailDomains?: Array<string> | undefined;
    exportFormats?: Array<string> | undefined;
    exportSchedule?: string | undefined;
    exportDestinations?: Array<string> | undefined;
    exportDestinationConfig?: { [k: string]: string } | undefined;
    compressExports?: boolean | undefined;
    compressionFormat?: string | undefined;
    salesforceEnabled?: boolean | undefined;
    salesforceConfig?: string | undefined;
    hubspotEnabled?: boolean | undefined;
    hubspotConfig?: string | undefined;
    zapierEnabled?: boolean | undefined;
    zapierWebhook?: string | undefined;
    activeIntegrations?: Array<string> | undefined;
    integrationSettings?: { [k: string]: string } | undefined;
  };

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsWorkspaces$outboundSchema:
  z.ZodType<
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsWorkspaces$Outbound,
    z.ZodTypeDef,
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsWorkspaces
  > = z.object({
    id: z.string().optional(),
    name: z.string().optional(),
    industry: z.string().optional(),
    domain: z.string().optional(),
    gdprCompliant: z.boolean().optional(),
    hipaaCompliant: z.boolean().optional(),
    soc2Compliant: z.boolean().optional(),
    storageQuota: z.string().optional(),
    usedStorage: z.string().optional(),
    createdAt: z.date().transform(v => v.toISOString()).optional(),
    updatedAt: z.date().transform(v => v.toISOString()).optional(),
    deletedAt: z.date().transform(v => v.toISOString()).optional(),
    workflows: z.array(
      z.lazy(() =>
        PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsWorkflows$outboundSchema
      ),
    ).optional(),
    jobsRunThisMonth: z.number().int().optional(),
    workspaceJobLimit: z.number().int().optional(),
    dailyJobQuota: z.number().int().optional(),
    activeScrapers: z.number().int().optional(),
    totalLeadsCollected: z.number().int().optional(),
    lastJobRun: z.date().transform(v => v.toISOString()).optional(),
    scrapingJobs: z.array(
      z.lazy(() =>
        PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsScrapingJobs$outboundSchema
      ),
    ).optional(),
    apiKeys: z.array(
      z.lazy(() =>
        PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsApiKeys$outboundSchema
      ),
    ).optional(),
    webhooks: z.array(
      z.lazy(() =>
        PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsWebhooks$outboundSchema
      ),
    ).optional(),
    workspaceType:
      PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsWorkspaceType$outboundSchema
        .default("WORKSPACE_TYPE_UNSPECIFIED"),
    description: z.string().optional(),
    metadata: z.record(z.string()).optional(),
    tags: z.array(z.string()).optional(),
    maxTeamMembers: z.number().int().optional(),
    currentTeamMembers: z.number().int().optional(),
    allowGuestAccess: z.boolean().optional(),
    allowedEmailDomains: z.array(z.string()).optional(),
    exportFormats: z.array(z.string()).optional(),
    exportSchedule: z.string().optional(),
    exportDestinations: z.array(z.string()).optional(),
    exportDestinationConfig: z.record(z.string()).optional(),
    compressExports: z.boolean().optional(),
    compressionFormat: z.string().optional(),
    salesforceEnabled: z.boolean().optional(),
    salesforceConfig: z.string().optional(),
    hubspotEnabled: z.boolean().optional(),
    hubspotConfig: z.string().optional(),
    zapierEnabled: z.boolean().optional(),
    zapierWebhook: z.string().optional(),
    activeIntegrations: z.array(z.string()).optional(),
    integrationSettings: z.record(z.string()).optional(),
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsWorkspaces$ {
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsWorkspaces$inboundSchema` instead. */
  export const inboundSchema =
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsWorkspaces$inboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsWorkspaces$outboundSchema` instead. */
  export const outboundSchema =
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsWorkspaces$outboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsWorkspaces$Outbound` instead. */
  export type Outbound =
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsWorkspaces$Outbound;
}

export function postApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsWorkspacesToJSON(
  postApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsWorkspaces:
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsWorkspaces,
): string {
  return JSON.stringify(
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsWorkspaces$outboundSchema
      .parse(
        postApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsWorkspaces,
      ),
  );
}

export function postApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsWorkspacesFromJSON(
  jsonString: string,
): SafeParseResult<
  PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsWorkspaces,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsWorkspaces$inboundSchema
        .parse(JSON.parse(x)),
    `Failed to parse 'PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsWorkspaces' from JSON`,
  );
}

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsSettings$inboundSchema:
  z.ZodType<
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsSettings,
    z.ZodTypeDef,
    unknown
  > = z.object({
    id: z.string().optional(),
    emailNotifications: z.boolean().optional(),
    slackNotifications: z.boolean().optional(),
    defaultDataRetention: z.string().optional(),
    autoPurgeEnabled: z.boolean().optional(),
    require2fa: z.boolean().optional(),
    sessionTimeout: z.string().optional(),
    createdAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    updatedAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    deletedAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
  });

/** @internal */
export type PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsSettings$Outbound =
  {
    id?: string | undefined;
    emailNotifications?: boolean | undefined;
    slackNotifications?: boolean | undefined;
    defaultDataRetention?: string | undefined;
    autoPurgeEnabled?: boolean | undefined;
    require2fa?: boolean | undefined;
    sessionTimeout?: string | undefined;
    createdAt?: string | undefined;
    updatedAt?: string | undefined;
    deletedAt?: string | undefined;
  };

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsSettings$outboundSchema:
  z.ZodType<
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsSettings$Outbound,
    z.ZodTypeDef,
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsSettings
  > = z.object({
    id: z.string().optional(),
    emailNotifications: z.boolean().optional(),
    slackNotifications: z.boolean().optional(),
    defaultDataRetention: z.string().optional(),
    autoPurgeEnabled: z.boolean().optional(),
    require2fa: z.boolean().optional(),
    sessionTimeout: z.string().optional(),
    createdAt: z.date().transform(v => v.toISOString()).optional(),
    updatedAt: z.date().transform(v => v.toISOString()).optional(),
    deletedAt: z.date().transform(v => v.toISOString()).optional(),
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsSettings$ {
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsSettings$inboundSchema` instead. */
  export const inboundSchema =
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsSettings$inboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsSettings$outboundSchema` instead. */
  export const outboundSchema =
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsSettings$outboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsSettings$Outbound` instead. */
  export type Outbound =
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsSettings$Outbound;
}

export function postApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsSettingsToJSON(
  postApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsSettings:
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsSettings,
): string {
  return JSON.stringify(
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsSettings$outboundSchema
      .parse(
        postApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsSettings,
      ),
  );
}

export function postApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsSettingsFromJSON(
  jsonString: string,
): SafeParseResult<
  PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsSettings,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsSettings$inboundSchema
        .parse(JSON.parse(x)),
    `Failed to parse 'PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsSettings' from JSON`,
  );
}

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsAccounts$inboundSchema:
  z.ZodType<
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsAccounts,
    z.ZodTypeDef,
    unknown
  > = z.object({
    id: z.string().optional(),
    authPlatformUserId: z.string().optional(),
    email: z.string().optional(),
    deletedAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    createdAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    accountStatus:
      PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsAccountStatus$inboundSchema
        .default("ACCOUNT_STATUS_UNSPECIFIED"),
    roles: z.array(
      PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsRoles$inboundSchema,
    ).optional(),
    permissions: z.array(
      PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsPermissions$inboundSchema,
    ).optional(),
    mfaEnabled: z.boolean().optional(),
    lastLoginAt: z.string().datetime({ offset: true }).transform(v =>
      new Date(v)
    ).optional(),
    timezone:
      PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTimezone$inboundSchema
        .default("TIMEZONE_UNSPECIFIED"),
    totalJobsRun: z.number().int().optional(),
    monthlyJobLimit: z.number().int().optional(),
    concurrentJobLimit: z.number().int().optional(),
    workspaces: z.array(
      z.lazy(() =>
        PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsWorkspaces$inboundSchema
      ),
    ).optional(),
    settings: z.lazy(() =>
      PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsSettings$inboundSchema
    ).optional(),
  });

/** @internal */
export type PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsAccounts$Outbound =
  {
    id?: string | undefined;
    authPlatformUserId?: string | undefined;
    email?: string | undefined;
    deletedAt?: string | undefined;
    createdAt?: string | undefined;
    accountStatus: string;
    roles?: Array<string> | undefined;
    permissions?: Array<string> | undefined;
    mfaEnabled?: boolean | undefined;
    lastLoginAt?: string | undefined;
    timezone: string;
    totalJobsRun?: number | undefined;
    monthlyJobLimit?: number | undefined;
    concurrentJobLimit?: number | undefined;
    workspaces?:
      | Array<
        PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsWorkspaces$Outbound
      >
      | undefined;
    settings?:
      | PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsSettings$Outbound
      | undefined;
  };

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsAccounts$outboundSchema:
  z.ZodType<
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsAccounts$Outbound,
    z.ZodTypeDef,
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsAccounts
  > = z.object({
    id: z.string().optional(),
    authPlatformUserId: z.string().optional(),
    email: z.string().optional(),
    deletedAt: z.date().transform(v => v.toISOString()).optional(),
    createdAt: z.date().transform(v => v.toISOString()).optional(),
    accountStatus:
      PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsAccountStatus$outboundSchema
        .default("ACCOUNT_STATUS_UNSPECIFIED"),
    roles: z.array(
      PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsRoles$outboundSchema,
    ).optional(),
    permissions: z.array(
      PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsPermissions$outboundSchema,
    ).optional(),
    mfaEnabled: z.boolean().optional(),
    lastLoginAt: z.date().transform(v => v.toISOString()).optional(),
    timezone:
      PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTimezone$outboundSchema
        .default("TIMEZONE_UNSPECIFIED"),
    totalJobsRun: z.number().int().optional(),
    monthlyJobLimit: z.number().int().optional(),
    concurrentJobLimit: z.number().int().optional(),
    workspaces: z.array(
      z.lazy(() =>
        PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsWorkspaces$outboundSchema
      ),
    ).optional(),
    settings: z.lazy(() =>
      PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsSettings$outboundSchema
    ).optional(),
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsAccounts$ {
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsAccounts$inboundSchema` instead. */
  export const inboundSchema =
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsAccounts$inboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsAccounts$outboundSchema` instead. */
  export const outboundSchema =
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsAccounts$outboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsAccounts$Outbound` instead. */
  export type Outbound =
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsAccounts$Outbound;
}

export function postApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsAccountsToJSON(
  postApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsAccounts:
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsAccounts,
): string {
  return JSON.stringify(
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsAccounts$outboundSchema
      .parse(
        postApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsAccounts,
      ),
  );
}

export function postApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsAccountsFromJSON(
  jsonString: string,
): SafeParseResult<
  PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsAccounts,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsAccounts$inboundSchema
        .parse(JSON.parse(x)),
    `Failed to parse 'PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsAccounts' from JSON`,
  );
}

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsRequestRequestBodyTenantStatus$inboundSchema:
  z.ZodNativeEnum<
    typeof PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsRequestRequestBodyTenantStatus
  > = z.nativeEnum(
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsRequestRequestBodyTenantStatus,
  );

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsRequestRequestBodyTenantStatus$outboundSchema:
  z.ZodNativeEnum<
    typeof PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsRequestRequestBodyTenantStatus
  > =
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsRequestRequestBodyTenantStatus$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsRequestRequestBodyTenantStatus$ {
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsRequestRequestBodyTenantStatus$inboundSchema` instead. */
  export const inboundSchema =
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsRequestRequestBodyTenantStatus$inboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsRequestRequestBodyTenantStatus$outboundSchema` instead. */
  export const outboundSchema =
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsRequestRequestBodyTenantStatus$outboundSchema;
}

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsScopes$inboundSchema:
  z.ZodNativeEnum<
    typeof PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsScopes
  > = z.nativeEnum(
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsScopes,
  );

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsScopes$outboundSchema:
  z.ZodNativeEnum<
    typeof PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsScopes
  > =
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsScopes$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsScopes$ {
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsScopes$inboundSchema` instead. */
  export const inboundSchema =
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsScopes$inboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsScopes$outboundSchema` instead. */
  export const outboundSchema =
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsScopes$outboundSchema;
}

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsApiKeys$inboundSchema:
  z.ZodType<
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsApiKeys,
    z.ZodTypeDef,
    unknown
  > = z.object({
    id: z.string().optional(),
    keyHash: z.string().optional(),
    keyPrefix: z.string().optional(),
    name: z.string().optional(),
    description: z.string().optional(),
    status:
      PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsRequestRequestBodyTenantStatus$inboundSchema
        .default("STATUS_UNSPECIFIED"),
    scopes: z.array(
      PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsScopes$inboundSchema,
    ).optional(),
    maxUses: z.number().int().optional(),
    allowedIps: z.array(z.string()).optional(),
    useCount: z.number().int().optional(),
    expiresAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    createdAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    updatedAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    deletedAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
  });

/** @internal */
export type PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsApiKeys$Outbound =
  {
    id?: string | undefined;
    keyHash?: string | undefined;
    keyPrefix?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    status: string;
    scopes?: Array<string> | undefined;
    maxUses?: number | undefined;
    allowedIps?: Array<string> | undefined;
    useCount?: number | undefined;
    expiresAt?: string | undefined;
    createdAt?: string | undefined;
    updatedAt?: string | undefined;
    deletedAt?: string | undefined;
  };

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsApiKeys$outboundSchema:
  z.ZodType<
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsApiKeys$Outbound,
    z.ZodTypeDef,
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsApiKeys
  > = z.object({
    id: z.string().optional(),
    keyHash: z.string().optional(),
    keyPrefix: z.string().optional(),
    name: z.string().optional(),
    description: z.string().optional(),
    status:
      PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsRequestRequestBodyTenantStatus$outboundSchema
        .default("STATUS_UNSPECIFIED"),
    scopes: z.array(
      PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsScopes$outboundSchema,
    ).optional(),
    maxUses: z.number().int().optional(),
    allowedIps: z.array(z.string()).optional(),
    useCount: z.number().int().optional(),
    expiresAt: z.date().transform(v => v.toISOString()).optional(),
    createdAt: z.date().transform(v => v.toISOString()).optional(),
    updatedAt: z.date().transform(v => v.toISOString()).optional(),
    deletedAt: z.date().transform(v => v.toISOString()).optional(),
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsApiKeys$ {
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsApiKeys$inboundSchema` instead. */
  export const inboundSchema =
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsApiKeys$inboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsApiKeys$outboundSchema` instead. */
  export const outboundSchema =
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsApiKeys$outboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsApiKeys$Outbound` instead. */
  export type Outbound =
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsApiKeys$Outbound;
}

export function postApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsApiKeysToJSON(
  postApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsApiKeys:
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsApiKeys,
): string {
  return JSON.stringify(
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsApiKeys$outboundSchema
      .parse(
        postApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsApiKeys,
      ),
  );
}

export function postApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsApiKeysFromJSON(
  jsonString: string,
): SafeParseResult<
  PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsApiKeys,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsApiKeys$inboundSchema
        .parse(JSON.parse(x)),
    `Failed to parse 'PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsApiKeys' from JSON`,
  );
}

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsRequestRequestBodyTenantStatus1$inboundSchema:
  z.ZodNativeEnum<
    typeof PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsRequestRequestBodyTenantStatus1
  > = z.nativeEnum(
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsRequestRequestBodyTenantStatus1,
  );

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsRequestRequestBodyTenantStatus1$outboundSchema:
  z.ZodNativeEnum<
    typeof PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsRequestRequestBodyTenantStatus1
  > =
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsRequestRequestBodyTenantStatus1$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsRequestRequestBodyTenantStatus1$ {
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsRequestRequestBodyTenantStatus1$inboundSchema` instead. */
  export const inboundSchema =
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsRequestRequestBodyTenantStatus1$inboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsRequestRequestBodyTenantStatus1$outboundSchema` instead. */
  export const outboundSchema =
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsRequestRequestBodyTenantStatus1$outboundSchema;
}

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenant$inboundSchema:
  z.ZodType<
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenant,
    z.ZodTypeDef,
    unknown
  > = z.object({
    id: z.string().optional(),
    name: z.string().optional(),
    displayName: z.string().optional(),
    description: z.string().optional(),
    apiBaseUrl: z.string().optional(),
    environmentVariables: z.record(z.string()).optional(),
    allowedOrigins: z.array(z.string()).optional(),
    storageQuota: z.string().optional(),
    monthlyRequestLimit: z.string().optional(),
    maxConcurrentJobs: z.number().int().optional(),
    enableCaching: z.boolean().optional(),
    enableRateLimiting: z.boolean().optional(),
    enableRequestLogging: z.boolean().optional(),
    accounts: z.array(
      z.lazy(() =>
        PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsAccounts$inboundSchema
      ),
    ).optional(),
    apiKeys: z.array(
      z.lazy(() =>
        PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsApiKeys$inboundSchema
      ),
    ).optional(),
    totalRequests: z.string().optional(),
    totalStorageUsed: z.string().optional(),
    averageResponseTime: z.number().optional(),
    createdAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    updatedAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    deletedAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    status:
      PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsRequestRequestBodyTenantStatus1$inboundSchema
        .default("STATUS_UNSPECIFIED"),
  });

/** @internal */
export type PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenant$Outbound =
  {
    id?: string | undefined;
    name?: string | undefined;
    displayName?: string | undefined;
    description?: string | undefined;
    apiBaseUrl?: string | undefined;
    environmentVariables?: { [k: string]: string } | undefined;
    allowedOrigins?: Array<string> | undefined;
    storageQuota?: string | undefined;
    monthlyRequestLimit?: string | undefined;
    maxConcurrentJobs?: number | undefined;
    enableCaching?: boolean | undefined;
    enableRateLimiting?: boolean | undefined;
    enableRequestLogging?: boolean | undefined;
    accounts?:
      | Array<
        PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsAccounts$Outbound
      >
      | undefined;
    apiKeys?:
      | Array<
        PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsApiKeys$Outbound
      >
      | undefined;
    totalRequests?: string | undefined;
    totalStorageUsed?: string | undefined;
    averageResponseTime?: number | undefined;
    createdAt?: string | undefined;
    updatedAt?: string | undefined;
    deletedAt?: string | undefined;
    status: string;
  };

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenant$outboundSchema:
  z.ZodType<
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenant$Outbound,
    z.ZodTypeDef,
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenant
  > = z.object({
    id: z.string().optional(),
    name: z.string().optional(),
    displayName: z.string().optional(),
    description: z.string().optional(),
    apiBaseUrl: z.string().optional(),
    environmentVariables: z.record(z.string()).optional(),
    allowedOrigins: z.array(z.string()).optional(),
    storageQuota: z.string().optional(),
    monthlyRequestLimit: z.string().optional(),
    maxConcurrentJobs: z.number().int().optional(),
    enableCaching: z.boolean().optional(),
    enableRateLimiting: z.boolean().optional(),
    enableRequestLogging: z.boolean().optional(),
    accounts: z.array(
      z.lazy(() =>
        PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsAccounts$outboundSchema
      ),
    ).optional(),
    apiKeys: z.array(
      z.lazy(() =>
        PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsApiKeys$outboundSchema
      ),
    ).optional(),
    totalRequests: z.string().optional(),
    totalStorageUsed: z.string().optional(),
    averageResponseTime: z.number().optional(),
    createdAt: z.date().transform(v => v.toISOString()).optional(),
    updatedAt: z.date().transform(v => v.toISOString()).optional(),
    deletedAt: z.date().transform(v => v.toISOString()).optional(),
    status:
      PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantsRequestRequestBodyTenantStatus1$outboundSchema
        .default("STATUS_UNSPECIFIED"),
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenant$ {
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenant$inboundSchema` instead. */
  export const inboundSchema =
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenant$inboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenant$outboundSchema` instead. */
  export const outboundSchema =
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenant$outboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenant$Outbound` instead. */
  export type Outbound =
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenant$Outbound;
}

export function postApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantToJSON(
  postApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenant:
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenant,
): string {
  return JSON.stringify(
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenant$outboundSchema
      .parse(
        postApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenant,
      ),
  );
}

export function postApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenantFromJSON(
  jsonString: string,
): SafeParseResult<
  PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenant,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenant$inboundSchema
        .parse(JSON.parse(x)),
    `Failed to parse 'PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenant' from JSON`,
  );
}

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsRequestBody$inboundSchema:
  z.ZodType<
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsRequestBody,
    z.ZodTypeDef,
    unknown
  > = z.object({
    tenant: z.lazy(() =>
      PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenant$inboundSchema
    ).optional(),
  });

/** @internal */
export type PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsRequestBody$Outbound =
  {
    tenant?:
      | PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenant$Outbound
      | undefined;
  };

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsRequestBody$outboundSchema:
  z.ZodType<
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsRequestBody$Outbound,
    z.ZodTypeDef,
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsRequestBody
  > = z.object({
    tenant: z.lazy(() =>
      PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsTenant$outboundSchema
    ).optional(),
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsRequestBody$ {
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsRequestBody$inboundSchema` instead. */
  export const inboundSchema =
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsRequestBody$inboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsRequestBody$outboundSchema` instead. */
  export const outboundSchema =
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsRequestBody$outboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsRequestBody$Outbound` instead. */
  export type Outbound =
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsRequestBody$Outbound;
}

export function postApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsRequestBodyToJSON(
  postApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsRequestBody:
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsRequestBody,
): string {
  return JSON.stringify(
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsRequestBody$outboundSchema
      .parse(
        postApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsRequestBody,
      ),
  );
}

export function postApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsRequestBodyFromJSON(
  jsonString: string,
): SafeParseResult<
  PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsRequestBody,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsRequestBody$inboundSchema
        .parse(JSON.parse(x)),
    `Failed to parse 'PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsRequestBody' from JSON`,
  );
}

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsRequest$inboundSchema:
  z.ZodType<
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsRequest,
    z.ZodTypeDef,
    unknown
  > = z.object({
    organizationId: z.string(),
    RequestBody: z.lazy(() =>
      PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsRequestBody$inboundSchema
    ),
  }).transform((v) => {
    return remap$(v, {
      "RequestBody": "requestBody",
    });
  });

/** @internal */
export type PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsRequest$Outbound =
  {
    organizationId: string;
    RequestBody:
      PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsRequestBody$Outbound;
  };

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsRequest$outboundSchema:
  z.ZodType<
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsRequest$Outbound,
    z.ZodTypeDef,
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsRequest
  > = z.object({
    organizationId: z.string(),
    requestBody: z.lazy(() =>
      PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsRequestBody$outboundSchema
    ),
  }).transform((v) => {
    return remap$(v, {
      requestBody: "RequestBody",
    });
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsRequest$ {
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsRequest$inboundSchema` instead. */
  export const inboundSchema =
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsRequest$inboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsRequest$outboundSchema` instead. */
  export const outboundSchema =
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsRequest$outboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsRequest$Outbound` instead. */
  export type Outbound =
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsRequest$Outbound;
}

export function postApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsRequestToJSON(
  postApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsRequest:
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsRequest,
): string {
  return JSON.stringify(
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsRequest$outboundSchema
      .parse(
        postApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsRequest,
      ),
  );
}

export function postApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsRequestFromJSON(
  jsonString: string,
): SafeParseResult<
  PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsRequest,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsRequest$inboundSchema
        .parse(JSON.parse(x)),
    `Failed to parse 'PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsRequest' from JSON`,
  );
}

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsResponseBody$inboundSchema:
  z.ZodType<
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsResponseBody,
    z.ZodTypeDef,
    unknown
  > = z.object({
    tenantId: z.string().optional(),
  });

/** @internal */
export type PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsResponseBody$Outbound =
  {
    tenantId?: string | undefined;
  };

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsResponseBody$outboundSchema:
  z.ZodType<
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsResponseBody$Outbound,
    z.ZodTypeDef,
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsResponseBody
  > = z.object({
    tenantId: z.string().optional(),
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsResponseBody$ {
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsResponseBody$inboundSchema` instead. */
  export const inboundSchema =
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsResponseBody$inboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsResponseBody$outboundSchema` instead. */
  export const outboundSchema =
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsResponseBody$outboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsResponseBody$Outbound` instead. */
  export type Outbound =
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsResponseBody$Outbound;
}

export function postApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsResponseBodyToJSON(
  postApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsResponseBody:
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsResponseBody,
): string {
  return JSON.stringify(
    PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsResponseBody$outboundSchema
      .parse(
        postApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsResponseBody,
      ),
  );
}

export function postApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsResponseBodyFromJSON(
  jsonString: string,
): SafeParseResult<
  PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsResponseBody,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsResponseBody$inboundSchema
        .parse(JSON.parse(x)),
    `Failed to parse 'PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsResponseBody' from JSON`,
  );
}
